/* eslint-disable complexity */
/* eslint-disable max-len,no-loop-func,no-unused-vars,no-inner-declarations,prefer-destructuring,no-trailing-spaces,no-param-reassign */
/* eslint-disable no-useless-escape */
/* eslint-disable no-undef */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-new-func */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-multi-assign */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-mixed-operators */
/* eslint-disable new-cap */
/* eslint-disable no-var */
/* eslint-disable no-redeclare */
/* eslint-disable camelcase */
import { AutoShapeType, PresetShapeModels, ST_ShapeType, ToAutoShapeType } from './present-shape-models';
import PathCalc from './pathCalc';
import { GraphicsType } from './graphic-type';
import has from 'lodash/has';

let numberDecimalSeparator = '.';
let listSeparator = ',';
let arrayGroupSeparator = ';';
let arrayListSeparator = ',';
const keyword_null = null;
const keyword_undefined = void 0;
const Math_abs = Math.abs;
const Math_min = Math.min;
const Math_max = Math.max;
const Math_pow = Math.pow;
const Math_atan2 = Math.atan2;
const Math_sin = Math.sin;
const Math_cos = Math.cos;

const const_number = 'number';
const const_string = 'string';
const const_boolean = 'boolean';
const const_true = 'TRUE';
const const_false = 'FALSE';
const const_array = 'ARRAY';
const const_null = '#NULL!';
const const_div0 = '#DIV/0!';
const const_value = '#VALUE!';
const const_ref = '#REF!';
const const_name = '#NAME?';
const const_na = '#N/A';
const const_num = '#NUM!';
const ErrorList = [const_null, const_div0, const_value, const_ref, const_name, const_na, const_num];
const ErrorCodeList = [0x00, 0x07, 0x0f, 0x17, 0x1d, 0x2a, 0x24];

const shapeProperties = [
  'left',
  'top',
  'width',
  'height',
  'angle',
  'isSelected',
  'relativeX',
  'relativeY',
  'relativeWidth',
  'relativeHeight',
];

const doubleArgDefaultValue = { _argType: 0 };
const operaterTypesMap = {
  ':': 15,
  ',': 16,
  '+': 3,
  '-': 4,
  '*': 5,
  '/': 6,
  '^': 7,
  '%': 2,
  '&': 8,
  '=': 9,
  '<': 11,
  '<>': 10,
  '<=': 12,
  '>': 13,
  '>=': 14,
};
const preOperaterTypesMap = {
  '+': 0,
  '-': 1,
};
var binaryOperatorPriorities = {
  ':': 1,
  '^': 2,
  ' ': 3,
  '*': 4,
  '/': 4,
  ',': 5,
  '+': 6,
  '-': 6,
  '&': 7,
  '<': 8,
  '=': 8,
  '>': 8,
  '>=': 8,
  '<=': 8,
  '<>': 8,
};
const OperatorTypeStringMap = [
  '+',
  '-',
  '%',
  '+',
  '-',
  '*',
  '/',
  '^',
  '&',
  '=',
  '<>',
  '<',
  '<=',
  '>',
  '>=',
  ':',
  ',',
  ' ',
];
var binaryOperatorPriorities = {
  ':': 1,
  '^': 2,
  ' ': 3,
  '*': 4,
  '/': 4,
  ',': 5,
  '+': 6,
  '-': 6,
  '&': 7,
  '<': 8,
  '=': 8,
  '>': 8,
  '>=': 8,
  '<=': 8,
  '<>': 8,
};

// =================预设操作里用到的计算函数实现==========================
function BOUND(v, type, ignore, min, max) {
  if (ignore) {
    return v;
  }

  if (type === 2) {
    return v;
  }
  if (type === 1) {
    min += 1;
    max -= 1;
  }

  return Math.max(min, Math.min(v, max));
}
function LISTORDER(ctx) {
  const { calcSource } = ctx;
  const parentId = calcSource.getValue(ctx.id, 'parentId');
  const parent = calcSource.getShapeById(parentId);
  const shapes = parent && parent.shapes;
  if (shapes) {
    for (let i = 0, len = shapes.length; i < len; i++) {
      if (shapes[i].id === ctx.id) {
        return i + 1;
      }
    }
  }
  return -1;
}

const ExcelDegreeToRadians = (60000 * 180) / Math.PI;
function CONVERTANGLE(radiusX, radiusY, angle) {
  const radians = angle / ExcelDegreeToRadians;
  return Math_atan2(radiusX * Math_sin(radians), radiusY * Math_cos(radians));
}

function GETCENTER(radius, coordinate, radians, isX) {
  const fn = isX ? Math_cos : Math_sin;
  return coordinate - radius * fn(radians);
}

function GETPOINT(coordinate, radius, radians, isX) {
  const fn = isX ? Math_cos : Math_sin;
  return coordinate + radius * fn(radians);
}

// ==================工具方法==========================================
function isString(value) {
  return typeof value === 'string';
}

const isDigit = function (c) {
  return c >= 48 && c <= 57;
};

const ArrayHelper_getLength = function (array) {
  return array && array.length;
};
const Types_each = function (obj, callback) {
  let value;
  const isArray = Array.isArray(obj);
  if (isArray) {
    for (let i = 0, { length } = obj; i < length; i++) {
      value = callback.call(obj[i], i, obj[i]);
      if (value === false) {
        break;
      }
    }
  } else {
    for (const p in obj) {
      if (obj.hasOwnProperty(p)) {
        value = callback.call(obj[p], p, obj[p]);
        if (value === false) {
          break;
        }
      }
    }
  }
  return obj;
};
function toUpperCase(str) {
  return str && str.toUpperCase();
}
const inArray = function (elem, arr, i) {
  let len;
  if (arr) {
    const core_indexOf = [].indexOf;
    if (core_indexOf) {
      return core_indexOf.call(arr, elem, i);
    }
    len = arr.length;
    if (Types._isNullOrUndefined(i)) {
      i = 0;
    }
    i = i < 0 ? Math.max(0, len + i) : i;
    for (; i < len; i++) {
      if (i in arr && arr[i] === elem) {
        return i;
      }
    }
  }
  return -1;
};
export function isCalcError(value) {
  return value instanceof CalcError;
}
function isNumber(value, strict) {
  return (
    typeof value === const_number ||
    value instanceof Date ||
    (!strict && (typeof value === const_boolean || (!isNaN(value) && !isNaN(parseFloat(value)))))
  );
}
function tryToBool(value, boolValue) {
  try {
    if (!value) {
      value = false;
    } else if (typeof value === const_boolean) {
      //
    } else if (value instanceof Date) {
      // value = dateTimeHelper._toOADate(value) !== 0;
    } else if (isNumber(value)) {
      value = value !== 0;
    } else {
      return false;
    }
  } catch (ex) {
    return false;
  }
  boolValue.value = value;
  return true;
}
function resolveName(context, name) {
  const n = name.indexOf('#');
  let id;
  if (n > 0) {
    id = name.substring(0, n);
    name = name.substring(n + 1);
  } else {
    id = context.id || context.calcSource.getCurrentObjectId();
  }

  name = name.replace(/V\./g, 'variables.');
  return {
    id,
    name,
  };
}
const conatArray = function (arr1, arr2) {
  arr1.push.apply(arr1, arr2);
  return arr1;
};

// ====================工具类======================================
var CalcError = (function () {
  function CalcError(error) {
    const err = CalcError._parseCore(error);
    if (err) {
      this._error = err.error;
      this._code = err.code;
    } else {
      throw 'Not Supported Exception';
    }
  }

  CalcError.prototype.toString = function () {
    return this._error;
  };
  CalcError.prototype.clone = function () {
    return new CalcError(this._error);
  };
  CalcError.prototype.toJSON = function () {
    return {
      _calcError: this._error,
      _code: this._code,
    };
  };

  CalcError.parse = function (value) {
    try {
      return new CalcError(value);
    } catch (e) {
      return keyword_undefined;
    }
  };
  CalcError._parseCore = function (value) {
    if (value) {
      for (let i = 0; i < ErrorList.length; i++) {
        const errItem = ErrorList[i];
        if (errItem === value || errItem === toUpperCase(value)) {
          return { error: errItem, code: ErrorCodeList[i] };
        }
      }
    }
    return keyword_undefined;
  };
  return CalcError;
})();
const Calc = {};
const errors = {};
Calc.Errors = {};
errors.Name = new CalcError(const_name);
errors.Null = new CalcError(const_null);
errors.DivideByZero = new CalcError(const_div0);
errors.NotAvailable = new CalcError(const_na);
const CalcErrorsValue = (errors.Value = new CalcError(const_value));
const CalcErrorsReference = (errors.Reference = new CalcError(const_ref));
// const CalcErrorsNumber = errors.Number = new CalcError(const_num);

var CalcArray = (Calc.CalcArray = function (array) {
  this.array = array;
});
const CalcErrorsName = errors.Name;
const CalcErrorsNotAvailable = errors.NotAvailable;
const CalcErrorsDivideByZero = errors.DivideByZero;
const Expression = (function () {
  function Expression(type) {
    const self = this;
    self.type = type;
  }
  return Expression;
})();
const CalcReference = function (calcSource, identities) {
  const self = this;
  self._source = calcSource;
  if (identities) {
    self._identities = identities;
    self._rangeCount = identities.length;
  } else {
    self._rangeCount = 1;
  }
};
const AsyncFunction = (function (_super) {
  function AsyncFunction(name, minArgs, maxArgs, description) {
    _super.call(this, name, minArgs, maxArgs, description);
  }

  return AsyncFunction;
})(Function);
var CalcArray = function (array) {
  this.array = array;
};

// = ====================核心类function===================================
var Functions = {
  Function(name, minArgs, maxArgs, functionDescription) {
    const self = this;
    const argumentsLength = arguments.length;

    self.name = name;

    self.minArgs = argumentsLength < 2 ? 0 : minArgs;

    self.maxArgs = argumentsLength < 3 ? 0 : maxArgs;
    self._description = functionDescription;

    self.typeName = '';
    return self;
  },
  findGlobalFunction(name) {
    name = name.toUpperCase();
    const buildInFuncs = Functions._builtInFunctions;
    return buildInFuncs && buildInFuncs[name];
  },

  acceptsArray() {
    return false;
  },

  acceptsReference() {
    return false;
  },

  acceptsError() {
    return false;
  },

  description() {
    const self = this;
    const builtInFunctionsResource = sR()._builtInFunctionsResource;
    return self._description ? self._description : builtInFunctionsResource && builtInFunctionsResource[self.name];
  },

  acceptsMissingArgument() {
    return false;
  },

  isVolatile() {
    return false;
  },

  isContextSensitive() {
    return false;
  },

  isBranch() {
    return false;
  },

  findTestArgument() {
    return -1;
  },

  findBranchArgument() {
    return -1;
  },
  expandRows() {
    return true;
  },
  expandColumns() {
    return true;
  },
  precedentReference() {
    return true;
  },
  returnReference() {
    return false;
  },

  evaluate() { },
  evaluateWithContext(context, args) {
    const self = this;
    let args1 = args;
    if (self.isContextSensitive()) {
      args1 = [context].concat(args1);
    }
    return self.evaluate.apply(self, args1);
  },

  toJSON() {
    const settings = {};
    for (const p in this) {
      if (this.hasOwnProperty(p)) {
        settings[p] = this[p];
      }
    }
    return settings;
  },

  fromJSON(settings) {
    if (!settings) {
      return;
    }
    for (const p in settings) {
      if (settings[p] !== keyword_undefined) {
        this[p] = settings[p];
      }
    }
  },

  mt_abs(number) {
    return Math.abs(number);
  },
  mt_sin(number) {
    return Math.sin(number);
  },
  mt_cos(number) {
    return Math.cos(number);
  },
  st_max(args1, args2) {
    return Math.max(args1, args2);
  },
  mt_tan(number) {
    return Math.tan(number);
  },
  mt_pi() {
    return Math.PI;
  },
  lg_true() {
    return true;
  },
  lg_false() {
    return false;
  },
  st_min(args1, args2) {
    return Math.min(args1, args2);
  },
  mt_sqrt(number) {
    return Math.sqrt(number);
  },
  mt_atan2(x, y) {
    if (x === 0.0 && y === 0.0) {
      return CalcErrorsDivideByZero;
    }
    return Math.atan2(y, x);
  },
  lg_if(logicalTest, valueIfTrue, valueIfFalse) {
    const arg0 = logicalTest;
    const arg1 = valueIfTrue;
    const val = tryExtractToSingleValue(arg0);
    let arg2;
    if (valueIfFalse !== keyword_undefined) {
      arg2 = valueIfFalse;
    } else {
      arg2 = ArrayHelper_getLength(arguments) === 2 ? false : 0;
    }
    const retValue = {};
    tryToBool(val.value, retValue);
    return retValue.value ? arg1 : arg2;
  },
};
const MyFunction = (function () {
  function MyFunction(name, minArgs, maxArgs, functionDescription) {
    const self = this;
    const argumentsLength = arguments.length;

    self.name = name;

    self.minArgs = argumentsLength < 2 ? 0 : minArgs;

    self.maxArgs = argumentsLength < 3 ? 0 : maxArgs;
    self._description = functionDescription;

    self.typeName = '';
  }

  MyFunction.prototype = {
    description() {
      const self = this;
      const builtInFunctionsResource = sR()._builtInFunctionsResource;
      return self._description ? self._description : builtInFunctionsResource && builtInFunctionsResource[self.name];
    },

    acceptsArray() {
      return false;
    },

    acceptsReference() {
      return false;
    },

    acceptsError() {
      return false;
    },

    acceptsMissingArgument() {
      return false;
    },

    isVolatile() {
      return false;
    },

    isContextSensitive() {
      return false;
    },

    isBranch() {
      return false;
    },

    findTestArgument() {
      return -1;
    },

    findBranchArgument() {
      return -1;
    },
    expandRows() {
      return true;
    },
    expandColumns() {
      return true;
    },
    precedentReference() {
      return true;
    },
    returnReference() {
      return false;
    },

    evaluate() { },
    evaluateWithContext(context, args) {
      const self = this;
      let args1 = args;
      if (self.isContextSensitive()) {
        args1 = [context].concat(args1);
      }
      return self.evaluate.apply(self, args1);
    },

    toJSON() {
      const settings = {};
      for (const p in this) {
        if (this.hasOwnProperty(p)) {
          settings[p] = this[p];
        }
      }
      return settings;
    },

    fromJSON(settings) {
      if (!settings) {
        return;
      }
      for (const p in settings) {
        if (settings[p] !== keyword_undefined) {
          this[p] = settings[p];
        }
      }
    },
  };
  MyFunction._create = function (name, fnEvaluate, options) {
    const fn = new Functions.Function(name, 0, 255);
    if (fnEvaluate && typeof fnEvaluate === 'function') {
      fn.evaluate = fnEvaluate;
    }
    if (options) {
      for (const prop in options) {
        if (options.hasOwnProperty(prop) && prop !== 'override') {
          fn[prop] = options[prop];
        }
      }
    }
    return fn;
  };
  return MyFunction;
})();
Functions.Function = MyFunction;
Functions._builtInFunctions = {};

const AcceptsHelper = {
  createNew(args) {
    this._args = args;
    return this;
  },
  _acceptsArgs(index) {
    let args = this._args;
    let i;
    if (!Array.isArray(args)) {
      args = [args];
    }
    if (args[0] === -1) {
      return true;
    }
    for (i = 0; i < args.length; i++) {
      let argAccepts = args[i];
      var sign;
      var num;
      if (isString(argAccepts)) {
        argAccepts = argAccepts.split(' ');
        sign = argAccepts[0];
        num = parseInt(argAccepts[1]);
        if (
          (sign === '!=' && index !== num) ||
          (sign === '>' && index > num) ||
          (sign === '>=' && index >= num) ||
          (sign === '%=' && index % 2 === num)
        ) {
          return true;
        }
      } else if (index === argAccepts) {
        return true;
      }
    }
    return false;
  },
  _checkArgs() {
    return this._args;
  },
};
function defineFunction(name, fnEvaluate, options) {
  if (name == undefined) {
    throw 'sR().Exp_InvalidFunctionName';
  }
  name = name.toUpperCase();
  if (Functions._builtInFunctions[name]) {
    // throw 'sR().Exp_InvalidOverrideFunction';
    return;
  }
  let fn = Functions._builtInFunctions[name];
  if (!fn) {
    Functions._builtInFunctions[name] = fn = new Functions.Function(name, 0, 255);
  } else if (!options || !options.override) {
    throw 'sR().Exp_OverrideNotAllowed';
  }
  if (fnEvaluate && typeof fnEvaluate === 'function') {
    fn.evaluate = fnEvaluate;
  }
  Types_each(options, (prop, value) => {
    let acceptHelper;
    if (
      inArray(prop, [
        'acceptsReference',
        'acceptsArray',
        'acceptsError',
        'acceptsMissingArgument',
        'precedentReference',
        'expandColumns',
        'expandRows',
      ]) >= 0
    ) {
      acceptHelper = AcceptsHelper.createNew(value);
      fn[prop] = function (index) {
        return acceptHelper._acceptsArgs(index);
      };
    } else if (
      inArray(prop, ['isVolatile', 'isBranch', 'findTestArgument', 'returnReference', 'isContextSensitive']) >= 0
    ) {
      acceptHelper = AcceptsHelper.createNew(value);
      fn[prop] = function () {
        return acceptHelper._checkArgs();
      };
    } else if (options.hasOwnProperty(prop) && prop !== 'override') {
      fn[prop] = value;
    }
  });
  return fn;
}
Functions._defineBuiltInFunction = function (
  name,
  fnEvaluate,
  minArgs,
  maxArgs,
  argsLimit,
  acceptsReference,
  acceptsArray,
  options,
) {
  if (!options) {
    options = {};
  }
  if (minArgs !== keyword_undefined) {
    options.minArgs = minArgs;
  }
  if (maxArgs !== keyword_undefined) {
    options.maxArgs = maxArgs;
  }
  if (acceptsReference !== keyword_undefined) {
    options.acceptsReference = acceptsReference;
  }
  if (acceptsArray !== keyword_undefined) {
    options.acceptsArray = acceptsArray;
  }
  if (argsLimit !== keyword_undefined) {
    options._argsLimit = argsLimit;
  }

  if (options._acceptsMissingArgument !== keyword_undefined) {
    options.acceptsMissingArgument = options._acceptsMissingArgument;
  }
  if (options._isVolatile !== keyword_undefined) {
    options.isVolatile = options._isVolatile;
  }
  if (options._isContextSensitive !== keyword_undefined) {
    options.isContextSensitive = options._isContextSensitive;
  }
  if (options._precedentReference !== keyword_undefined) {
    options.precedentReference = options._precedentReference;
  }
  if (options._arrayArgumentEvaluateMode !== keyword_undefined) {
    options.arrayArgumentEvaluateMode = options._arrayArgumentEvaluateMode;
  }
  if (options._acceptsError !== keyword_undefined) {
    options.acceptsError = options._acceptsError;
  }
  return defineFunction(name, fnEvaluate, options);
};

// = ====================核心类PropertyContext===================================
const PropertyContext = (function () {
  function PropertyContext(calcSource, id) {
    const self = this;
    self.id = id;
    self.calcSource = calcSource;
  }

  PropertyContext.prototype = {
    setSource(source) {
      this.calcSource = source;
    },

    getName(name) {
      const self = this;
      const t = resolveName(self, name);
      if (t.id && t.name) {
        return {
          type: 2,
          value: self.calcSource.getValue(t.id, t.name),
        };
      }

      return { type: 5, value: 'reference error' };
    },

    getExternalSourceToken(source) {
      return source.getName();
    },

    _isExpandArrayToMultiCall() {
      return false;
    },
    _beginExpandArrayToMultiCall() { },
    _endExpandArrayToMultiCall() { },
  };

  return PropertyContext;
})();

// = ====================核心类Parser===================================
var Parser = {
  initFound() {
    const defineBuiltInFunction = Functions._defineBuiltInFunction;
    defineBuiltInFunction('MAX', Functions.st_max, 1, keyword_undefined, keyword_undefined, -1, -1);
    defineBuiltInFunction('MIN', Functions.st_min, 1, keyword_undefined, keyword_undefined, -1, -1);
    defineBuiltInFunction('ABS', Functions.mt_abs, 1, 1, doubleArgDefaultValue);
    defineBuiltInFunction('COS', Functions.mt_cos, 1, 1, doubleArgDefaultValue);
    defineBuiltInFunction('TAN', Functions.mt_tan, 1, 1, doubleArgDefaultValue);
    defineBuiltInFunction('SIN', Functions.mt_sin, 1, 1, doubleArgDefaultValue);
    defineBuiltInFunction('PI', Functions.mt_pi, 0, 0);
    defineBuiltInFunction('TRUE', Functions.lg_true, 0, 0);
    defineBuiltInFunction('FALSE', Functions.lg_false, 0, 0);
    defineBuiltInFunction('SQRT', Functions.mt_sqrt, 1, 1, { _argType: 1, _argCondition: '< 0' });
    defineBuiltInFunction('ATAN2', Functions.mt_atan2, 2, 2, [doubleArgDefaultValue, doubleArgDefaultValue]);
    defineBuiltInFunction('IF', Functions.lg_if, 2, 3, keyword_undefined, [1, 2], [1, 2], {
      _acceptsError: [1, 2],
      _acceptsMissingArgument: 2,
      isBranch: true,
      findTestArgument: 0,
      findBranchArgument(test) {
        if (isCalcError(test)) {
          return -1;
        }
        const retValue = { value: false };
        tryToBool(test, retValue);
        return retValue.value ? 1 : 2;
      },
    });
  },
  judgeState(state, num, currentChar) {
    if (state === 0) {
      state = 2;
    } else if (state === 3) {
      state = 4;
    } else if (state === 1) {
      state = 2;
    } else if (state === 5 || state === 6) {
      state = 7;
    }
    num.push(currentChar);
    return state;
  },
  decimalSeparatorJudge(state, num) {
    let retFlag = false;
    if (state === 2) {
      state = 4;
    } else if (state === 0 || state === 1) {
      state = 3;
    } else {
      retFlag = true;
      // return {};
    }
    num.push('.');
    return { state, retFlag };
  },
  minusAndPlusChar(state, num, currentChar, i) {
    let endIndex;
    let retFlag = false;
    if (state === 0) {
      state = 1;
    } else if (state === 5) {
      state = 6;
    } else {
      retFlag = true;
      endIndex = i - 1;
    }
    num.push(currentChar);
    return { state, num, endIndex, retFlag };
  },
  stateToBe247(state) {
    return state === 2 || state === 4 || state === 7;
  },
  readNumber(str, startIndex, decimalSeparator) {
    const len = str.length;
    let state = 0;
    const num = [];
    for (let i = startIndex; i < len; i++) {
      const currentChar = str[i];
      if (isDigit(currentChar.charCodeAt(0))) {
        state = this.judgeState(state, num, currentChar);
      } else if (currentChar === decimalSeparator) {
        const res = this.decimalSeparatorJudge(state, num);
        if (res.retFlag) {
          return {};
        }
        // eslint-disable-next-line prefer-destructuring
        state = res.state;
      } else if (currentChar === '+' || currentChar === '-') {
        const res = this.minusAndPlusChar(state, num, currentChar, i);
        if (res.retFlag) {
          return { num: res.num, endIndex: res.endIndex };
        }
        // {state, num} = res;
        state = res.state;
      } else if (currentChar === 'E' || currentChar === 'e') {
        if (state === 2 || state === 4) {
          state = 5;
        } else {
          return {};
        }
        num.push(currentChar);
      } else if (this.stateToBe247(state)) {
        return { num, endIndex: i - 1 };
      }
    }
    if (this.stateToBe247(state)) {
      return { num, endIndex: len - 1 };
    }
    return {};
  },
  setParserOption(culture) {
    let option;
    let cultureOption;
    if (culture === keyword_undefined || !Common.CultureManager._getCultureInfo()) {
      option = {};
      cultureOption = option;
    } else {
      cultureOption = culture.NumberFormat
        ? culture.NumberFormat
        : Common.CultureManager._getCultureInfo().NumberFormat;
      option = culture ? cultureOption : {};
    }
    listSeparator = Parser.listSeparator = option.listSeparator || ',';
    numberDecimalSeparator = option.numberDecimalSeparator || '.';
    if (culture || !Parser.numberDecimalSeparator) {
      Parser.numberGroupSeparator = cultureOption.numberGroupSeparator || ',';
      Parser.numberDecimalSeparator = cultureOption.numberDecimalSeparator || '.';
    }
    arrayGroupSeparator = Parser.arrayGroupSeparator = option.arrayGroupSeparator || ';';
    arrayListSeparator = Parser.arrayListSeparator = option.arrayListSeparator || ',';
  },

  parse(context, formula) {
    // this.setParserOption(context.culture);
    const charArray = formula.split('');
    this._charArray = charArray;
    // var tokens = this.parseToTokens(context, charArray, !context.ignoreError);
    const tokens = this.parseToTokens(context, charArray, true);
    return this.buildExpressionTree(context, tokens, true);
  },
  unparse(context, expression, formulaCharArray) {
    formulaCharArray = formulaCharArray || [];
    this._unparseCore(context, expression, formulaCharArray);
    return formulaCharArray.join('');
  },
  unparse2(context, parser, expr, formula) {
    const self = this;
    if (expr.type === 6 || expr.type === 4 || expr.type === 2 || expr.type === 5 || expr.type === 3) {
      self._unparseConstantExpression(context, expr, formula);
    } else if (expr.type === 9) {
      self._unparseOperatorExpressions(context, parser, expr, formula);
    } else if (expr.type === 10) {
      formula.push('(');
      parser._unparseCore(context, expr.value, formula);
      formula.push(')');
    } else if (expr.type === 7) {
      conatArray(formula, ((expr.function && expr.function.name) || expr.functionName).split(''));
      formula.push('(');
      for (let i = 0; i < expr.arguments.length; i++) {
        if (i !== 0) {
          formula.push(listSeparator);
        }
        parser._unparseCore(context, expr.arguments[i], formula);
      }
      formula.push(')');
    } else if (expr.type === 1 || expr.type === 8) {
      self.unparseRefenceExpressions(context, parser, expr, formula);
      return true;
    } else {
      return false;
    }
    return true;
  },
  unparseRefenceExpressions(context, parser, expr, formula) {
    // if (expr.source === Calc.BangSource ) {
    //     formula.push('!');
    // } else
    if (expr.source) {
      const isSourceValid = this.unparseSource(context, formula, expr.source, expr.endSource);
      if (!isSourceValid) {
        formula.push('#', 'R', 'E', 'F', '!');
        return;
      }
    }
    if (expr.type === 8) {
      formula.push(expr.value);
    }
  },
  _unparseOperatorExpressions(context, parser, expr, formula) {
    const { operatorType } = expr;
    if (operatorType === 2) {
      parser._unparseCore(context, expr.value, formula);
      formula.push('%');
    } else if (operatorType === 0 || operatorType === 1) {
      formula.push(OperatorTypeStringMap[operatorType]);
      parser._unparseCore(context, expr.value, formula);
    } else {
      parser._unparseCore(context, expr.value, formula);
      formula.push(OperatorTypeStringMap[operatorType]);
      parser._unparseCore(context, expr.value2, formula);
    }
  },
  handleType6(formula, expr, errMsg) {
    formula.push('{');
    const array = expr.value;
    if (array.getRowCount() <= 0) {
      throw errMsg;
    }
    for (let rowIndex = 0, rowCount = array.getRowCount(); rowIndex < rowCount; rowIndex++) {
      if (rowIndex >= 1) {
        formula.push(arrayGroupSeparator);
      }
      for (let columnIndex = 0, columnCount = array.getColumnCount(); columnIndex < columnCount; columnIndex++) {
        if (columnIndex !== 0) {
          formula.push(arrayListSeparator);
        }
        const v = array.getValue(rowIndex, columnIndex);
        if (v === keyword_undefined || v === keyword_null) {
          throw errMsg;
        }
        const valueType = typeof v;

        if (valueType === const_string) {
          formula.push('"');
          formula.push(v);
          formula.push('"');
        } else if (valueType === const_boolean) {
          formula.push(v ? const_true : const_false);
        } else if (valueType === 'number' && numberDecimalSeparator !== '.') {
          formula.push(v.toString().replace('.', numberDecimalSeparator));
        } else {
          formula.push(v.toString());
        }
      }
    }
    formula.push('}');
  },
  _unparseConstantExpression(context, expr, formula) {
    const errMsg = 'Invalid array';
    if (expr.type === 3) {
      formula.push('"');

      formula.push(stringHelper._replace(expr.value, '"', '""'));
      formula.push('"');
    } else if (expr.type === 2) {
      let value = expr.originalValue || expr.value.toString();
      if (numberDecimalSeparator !== '.') {
        value = value.replace('.', numberDecimalSeparator);
      }
      formula.push(value);
    } else if (expr.type === 4) {
      formula.push(expr.value ? const_true : const_false);
    } else if (expr.type === 6) {
      this.handleType6(formula, expr, errMsg);
    } else if (expr.type === 5) {
      formula.push(expr.value.toString());
    } else if (expr.type === 11) {
      //
    }
  },
  _unparseCore(context, expression, formulaCharArray) {
    // this.setParserOption(context.culture);
    this.unparse2(context, this, expression, formulaCharArray);
  },
  parseToTokens(parserContext, charArray, throwError) {
    if (throwError === void 0) {
      throwError = true;
    }
    const self = this;
    const addOperand = function (tokenList, valueArray, start) {
      if (valueArray.length > 0) {
        tokenList.push(new FormulaToken(valueArray, 0, start));
        return [];
      }
      return valueArray;
    };
    const len = charArray.length;
    const tokens1 = [];
    const stack = [];
    let stackEnd = -1;
    let value = [];
    let currentToken;
    let tokenStartIndex;
    let startIndex = 0;
    let endIndex;
    let stackToken;

    const startIndexInit = () => {
      while (startIndex < len && charArray[startIndex] === ' ') {
        startIndex += 1;
      }
      if (charArray[startIndex] === '=') {
        startIndex += 1;
      }
      tokenStartIndex = startIndex;
    };

    startIndexInit();
    for (let index = startIndex; index < len; index++) {
      const currentChar = charArray[index];
      const currentCharCode = currentChar.charCodeAt();
      var rs;
      let inBranch = false;
      const valueJudge = () =>
        self._isR1C1 &&
        value.length === 0 &&
        (value[0] === 'R' || value[0] === 'r' || value[0] === 'C' || value[0] === 'c');
      const charCodeHandle1 = () => {
        if (inBranch) return;
        if ((currentCharCode >= 97 && currentCharCode <= 122) || (currentCharCode >= 65 && currentCharCode <= 90)) {
          inBranch = true;
          value.push(currentChar);
        } else if (currentCharCode === 34) {
          inBranch = true;
          rs = readString(charArray, index, '"', '"', '', throwError);
          if (rs) {
            const token = new FormulaToken(rs.result, 0, index, index + rs.result.length + 2, 3);
            if (rs.skipCount) {
              token._fullString = charArray.slice(index, rs.endIndex + 1).join('');
              token._endIndex += rs.skipCount;
            }
            tokens1.push(token);
            index = rs.endIndex;
            tokenStartIndex = index + 1;
          } else {
            conatArray(value, charArray.slice(index, len));
            index = len - 1;
          }
        } else if (currentCharCode === 39) {
          inBranch = true;
          rs = readString(charArray, index, '\'', '\'', '', throwError);
          if (rs) {
            value.push('\'');
            conatArray(value, rs.result);
            value.push('\'');
            index = rs.endIndex;
          } else {
            value.push('\'');
            index = len - 1;
          }
        }
      };
      const charCode13OR10 = () => (currentCharCode === 13 || currentChar === 10) && !inBranch;
      charCodeHandle1();
      if (currentCharCode === 91 && !inBranch) {
        inBranch = true;
        rs = readString(charArray, index, '[', ']', '\'', throwError);
        if (rs) {
          value.push('[');
          conatArray(value, rs.result);
          value.push(']');
          index = rs.endIndex;
        } else {
          if (valueJudge()) {
            continue;
          }
          conatArray(value, charArray.slice(index, len));
          index = len - 1;
        }
      } else if (charCode13OR10()) {
        inBranch = true;
        continue;
      }
      const charCodeHandle2 = () => {
        if (inBranch) return;
        if (currentCharCode === 35) {
          inBranch = true;
          const re = readError(charArray, index);
          if (re) {
            tokens1.push(new FormulaToken(re.result, 0, index, index + re.result.length - 1, 6));
            tokenStartIndex = index + 1;

            index = re.endIndex;
          } else {
            value.push(currentChar);
          }
        } else if (currentCharCode === 33) {
          inBranch = true;
          if (value.length === 0) {
            //
          }
          const tokenLength = tokens1.length;
          if (tokenLength > 0 && tokens1[tokenLength - 1]._type === 0) {
            const lastToken = tokens1[tokenLength - 1];
            lastToken._value.push.call(lastToken._value, value);
            tokens1[tokenLength - 1] = new FormulaToken(lastToken._value, 0, lastToken._index, index, 12);
          } else {
            tokens1.push(new FormulaToken(value, 0, tokenStartIndex, index, 12));
          }
          value = [];
          tokenStartIndex = index + 1;
        }
      };
      charCodeHandle2();
      const codeToBe43Or45 = () => currentCharCode === 43 || currentCharCode === 45;
      const handleCode43Or45 = () => {
        // if (inBranch) return;
        const previous = tokens1.length === 0 ? null : tokens1[tokens1.length - 1];
        if (value.length !== 0) {
          tokens1.push(new FormulaToken(value, 0, tokenStartIndex));
          tokens1.push(new FormulaToken(currentChar, 5, index));
          value = [];
          tokenStartIndex = index + 1;
        } else {
          if (previous && previous._type === 7) {
            tokens1.pop();
          }
          if (previous && (previous._subType === 2 || previous._type === 6 || previous._type === 0)) {
            tokens1.push(new FormulaToken(currentChar, 5, index));
            tokenStartIndex = index + 1;
          } else {
            tokens1.push(new FormulaToken(currentChar, 4, index));
            tokenStartIndex = index + 1;
          }
        }
      };
      const currentCharIsNDSOrCodeIsDigit = () => currentChar === numberDecimalSeparator || isDigit(currentCharCode);
      const handleCurrentCharIsNDSOrCodeIsDigit = () => {
        // if (inBranch) return;
        if (value.length > 0) {
          value.push(currentChar);
        } else {
          const isNum = this.readNumber(charArray, index, numberDecimalSeparator);
          if (isNum.num) {
            endIndex = isNum.endIndex;
            const { num } = isNum;

            if (endIndex <= len - 2 && charArray[endIndex + 1] === '!') {
              conatArray(value, num);
              tokenStartIndex = endIndex;
            } else {
              tokens1.push(new FormulaToken(num, 0, index, endIndex, 4));
              tokenStartIndex = endIndex + 1;
            }
            index = endIndex;
          } else {
            value.push(currentChar);
          }
        }
      };
      const handleCode123 = () => {
        // if (inBranch) return;
        if (value.length > 0 && throwError) {
          throwParseCharError(currentChar, index);
        }
        currentToken = new FormulaToken(const_array, 1, index, index, 1);
        tokens1.push(currentToken);
        stackEnd += 1;
        stack[stackEnd] = currentToken;
        tokenStartIndex = index + 1;
      };
      const charToBeAGSAndStackEnd = () =>
        currentChar === arrayGroupSeparator && stackEnd >= 0 && stack[stackEnd].value === const_array;
      const handleCharToBeAGSAndStackEnd = () => {
        // if (inBranch) return;
        inBranch = true;
        value = addOperand(tokens1, value, tokenStartIndex);
        if (stackEnd < 0 && throwError) {
          throwParseCharError(currentChar, index);
        }
        tokens1.push(new FormulaToken(arrayGroupSeparator, 3, index, index));
        tokenStartIndex = index + 1;
      };
      const handleCharCode125 = () => {
        // if (inBranch) return;
        value = addOperand(tokens1, value, tokenStartIndex);
        if (endIndex < 0 && throwError) {
          throwParseCharError(currentChar, index);
        }
        stackToken = stack[stackEnd];
        stackEnd -= 1;
        stackToken = new FormulaToken(currentChar, stackToken._type, index, index, 2);
        tokens1.push(stackToken);
        tokenStartIndex = index + 1;
      };
      const charCodeIsListORArraylistORArraygroup = () =>
        currentChar === listSeparator || currentChar === arrayListSeparator || currentChar === arrayGroupSeparator;
      const handleCharCodeIsListORArraylistORArraygroup = () => {
        // if (inBranch) return;
        value = addOperand(tokens1, value, tokenStartIndex);
        if (stackEnd < 0 || stack[stackEnd]._type !== 1) {
          tokens1.push(new FormulaToken(listSeparator, 5, index, index, 10));
        } else {
          tokens1.push(new FormulaToken(currentChar, 3, index, index));
        }
        tokenStartIndex = index + 1;
      };
      const indexANDOpType = () =>
        index + 2 <= len && operaterTypesMap[currentChar + charArray[index + 1]] && !inBranch;
      const handleCharToBeLeftQuote = () => {
        // if (inBranch) return;
        if (value.length > 0) {
          currentToken = new FormulaToken(value, 1, tokenStartIndex, index, 1);
          value = [];
        } else {
          currentToken = new FormulaToken(currentChar, 2, index, index, 1);
        }
        tokens1.push(currentToken);
        stackEnd += 1;
        stack[stackEnd] = currentToken;
        tokenStartIndex = index + 1;
      };
      const handleCharToBeRightQuote = () => {
        // if (inBranch) return;
        value = addOperand(tokens1, value, tokenStartIndex);
        if (stackEnd < 0) {
          throwError && throwParseCharError(currentChar, index);
          return;
        }
        stackToken = stack[stackEnd];
        stackEnd -= 1;
        stackToken = new FormulaToken(currentChar, stackToken._type, index, index, 2);
        tokens1.push(stackToken);
        tokenStartIndex = index + 1;
      };
      const charToBern = () => currentChar === '\r' || currentChar === '\n';
      const currentCharHandle = () => {
        const noHandleBranch = () => inBranch || charToBern();
        // eslint-disable-next-line no-empty
        if (noHandleBranch()) {
        } else if (codeToBe43Or45()) {
          // 这个分支一抽出来就报错
          handleCode43Or45();
        } else if (currentCharIsNDSOrCodeIsDigit()) {
          handleCurrentCharIsNDSOrCodeIsDigit();
        } else if (currentCharCode === 123) {
          handleCode123();
        } else if (charToBeAGSAndStackEnd()) {
          handleCharToBeAGSAndStackEnd();
        } else if (currentCharCode === 125) {
          handleCharCode125();
        } else if (currentCharCode === 32) {
          value = addOperand(tokens1, value, tokenStartIndex);
          tokenStartIndex = index + 1;
        } else if (charCodeIsListORArraylistORArraygroup()) {
          handleCharCodeIsListORArraylistORArraygroup();
        } else if (currentCharCode === 37) {
          value = addOperand(tokens1, value, tokenStartIndex);
          tokens1.push(new FormulaToken(charArray[index], 6, index, index));
          tokenStartIndex = index + 1;
        } else if (indexANDOpType()) {
          value = addOperand(tokens1, value, tokenStartIndex);
          tokens1.push(new FormulaToken(charArray.slice(index, index + 2), 5, index, index + 1, 5));
          index += 1;
          tokenStartIndex = index + 1;
        } else if (operaterTypesMap[currentChar]) {
          value = addOperand(tokens1, value, tokenStartIndex);
          tokens1.push(new FormulaToken(currentChar, 5, index, index));
          tokenStartIndex = index + 1;
        } else if (currentChar === '(') {
          handleCharToBeLeftQuote();
        } else if (currentChar === ')') {
          handleCharToBeRightQuote();
        } else if (currentChar === ':') {
          value = addOperand(tokens1, value, tokenStartIndex);
          tokens1.push(new FormulaToken(currentChar, 5, index, index, 11));
          tokenStartIndex = index + 1;
        } else {
          value.push(currentChar);
        }
      };
      currentCharHandle();
    }
    addOperand(tokens1, value, tokenStartIndex);

    return tokens1;
  },
  buildExpressionTree(parserContext, tokens, throwError) {
    const expressions = this._buildExpressionNodes(parserContext, tokens, throwError);
    const expr = this._buildExpressionsToTree(parserContext, expressions, throwError);
    if (throwError) {
      this._checkExpression(expr);
    }
    return expr;
  },
  _checkExpression(expr) {
    while (expr.type === 10) {
      expr = expr.value;
    }
    const self = this;
    if (expr.type === 9) {
      if (!expr.value) {
        throw 'Exp_FormulaInvalid';
      }
      self._checkExpression(expr.value);
      expr.value2 && self._checkExpression(expr.value2);
    } else if (expr.type === 7) {
      const args = expr.arguments;
      const count = args.length;
      const fn = expr.function;
      if (fn) {
        const min = fn.minArgs;
        const max = fn.maxArgs;
        if (count < min || count > max) {
          throw 'Exp_FormulaInvalid';
        }
      }
      for (let i = 0; i < count; i++) {
        const subExpr = args[i];
        if (!subExpr) {
          throw 'Exp_FormulaInvalid';
        }
        self._checkExpression(subExpr);
      }
    }
  },
  _buildExpressionsToTree(parserContext, expressions, throwError) {
    const binaryExprs = this._parseToBinaryOperatorList(parserContext, expressions, throwError);
    let currentExpression;
    let lastExpression;
    let nextExpression;
    let index;

    for (index = 3; index < binaryExprs.length;) {
      const nextToken = binaryExprs[index];
      let currentToken = binaryExprs[index - 2];
      if (currentToken.type !== 9) {
        throw 'Exp_FormulaInvalid';
      }
      if (nextToken && nextToken.type === 9) {
        while (
          index >= 3 &&
          binaryOperatorPriorities[nextToken.value] >= binaryOperatorPriorities[currentToken.value]
        ) {
          lastExpression = binaryExprs[index - 3];
          nextExpression = binaryExprs[index - 1];
          currentExpression = createOperatorExpression(currentToken.operatorType, lastExpression, nextExpression);
          binaryExprs.splice(index - 3, 3, currentExpression);
          index -= 2;
          if (index >= 3) {
            currentToken = binaryExprs[index - 2];
          }
        }
        index += 2;
      } else {
        index += 1;
      }
    }
    if (binaryExprs.length === 1) {
      return binaryExprs[0];
    }

    for (index = binaryExprs.length - 2; index > 0; index -= 2) {
      lastExpression = binaryExprs[index - 1];
      nextExpression = binaryExprs[index + 1];
      if (binaryExprs[index].type !== 9) {
        throw 'Exp_FormulaInvalid';
      }
      currentExpression = createOperatorExpression(binaryExprs[index].operatorType, lastExpression, nextExpression);
      binaryExprs.splice(index - 1, 3, currentExpression);
    }
    return currentExpression;
  },
  handleOperatorTypeZeroOne(i, expressions, context, newExpr) {
    let endIndex = i;
    while (expressions[endIndex].type === 9 && expressions[endIndex].operatorType <= 1) {
      endIndex += 1;
    }
    let operated = this._buildExpressionsToTree(context, expressions[endIndex]);
    for (let index = endIndex - 1; index >= i; index--) {
      newExpr = createOperatorExpression(expressions[index].operatorType, operated);
      operated = newExpr;
    }
    newExpr = operated;
    i = endIndex;
    return { i, newExpr };
  },
  handleType7(expr, context, newExpr) {
    let argIndex = 0;
    const functionArgs = expr.arguments;
    const newArgs = [];
    let argExprs = [];
    if (functionArgs.length > 0) {
      for (let j = 0; j <= functionArgs.length; j++) {
        const arg = functionArgs[j];
        if (j === functionArgs.length || (arg.type === 0 && arg.value === listSeparator)) {
          if (argIndex === j) {
            newArgs.push(new Expression(11));
          } else {
            newArgs.push(this._buildExpressionsToTree(context, argExprs));
          }
          argIndex = j + 1;
          argExprs = [];
        } else {
          argExprs.push(arg);
        }
      }
      expr.arguments = newArgs;
    }
    newExpr = expr;
    return { newExpr };
  },
  _parseToBinaryOperatorList(context, expressions, throwError) {
    expressions = Array.isArray(expressions) ? expressions : [expressions];
    const result = [];
    const { length } = expressions;
    for (let i = 0; i < length; i++) {
      const expr = expressions[i];
      let newExpr = expr;
      if (expr.type === 9) {
        if (expr.operatorType === 0 || expr.operatorType === 1) {
          if (i === length - 1) {
            throwError;
          } else {
            const __ret = this.handleOperatorTypeZeroOne(i, expressions, context, newExpr);
            i = __ret.i;
            newExpr = __ret.newExpr;
          }
        } else if (expr.operatorType === 2) {
          if (i === 0) {
            throwError;
          } else {
            newExpr = createOperatorExpression(
              expr.operatorType,
              this._buildExpressionsToTree(context, result[result.length - 1]),
            );
            result[result.length - 1] = newExpr;
            continue;
          }
        }
      } else if (expr.type === 10) {
        expr.value = this._buildExpressionsToTree(context, expr.value);
        newExpr = expr;
      } else if (expr.type === 7) {
        const __ret = this.handleType7(expr, context, newExpr);
        newExpr = __ret.newExpr;
      }
      result.push(newExpr);
    }
    return result;
  },
  _buildExpressionNodes(parserContext, tokens1, throwError) {
    const expressions = [];
    for (let i = 0, { length } = tokens1; i < length;) {
      i = this.resolveToken(parserContext, tokens1, expressions, i, throwError);
    }
    return expressions;
  },
  resolveToken(parserContext, tokens, expressions, currentTokenIndex) {
    // throwError
    const currentToken = tokens[currentTokenIndex];
    const result = this.resolveToken2(parserContext, this, tokens, currentTokenIndex);
    if (result) {
      let { expr } = result;
      const priviousIndex = currentTokenIndex - 1;
      if (expr && result.index !== keyword_undefined) {
        currentTokenIndex = result.index - 1;
      } else {
        expr = result;
      }

      const priviousExpr = expressions.length > 0 ? expressions[expressions.length - 1] : keyword_null;
      if (
        priviousExpr &&
        expr.type !== 0 &&
        expr.type !== 7 &&
        expr.type < 9 &&
        priviousExpr.type !== 0 &&
        priviousExpr.type !== 7 &&
        priviousExpr.type < 9
      ) {
        const priviousEnd = tokens[priviousIndex]._endIndex;
        if (priviousEnd < currentToken._index - 1) {
          expressions.push(createOperatorExpression(17, ' '));
        }
      }
      expressions.push(expr);
    }

    return currentTokenIndex + 1;
  },
  createOperatorExpression(operatorType, value, value2) {
    const expr = new Expression(9);
    expr.operatorType = operatorType;
    expr.value = value;
    expr.value2 = value2;
    return expr;
  },
  resolveSubTokens(parserContext, tokens, currentTokenIndex, throwError) {
    const subExpressions = [];
    while (currentTokenIndex < tokens.length && tokens[currentTokenIndex]._subType !== 2) {
      currentTokenIndex = this.resolveToken(parserContext, tokens, subExpressions, currentTokenIndex, throwError);
    }
    return { exprs: subExpressions, index: currentTokenIndex + 1 };
  },
  handleCurrentTokenTypeZero(currentToken, value, stringValue, expr) {
    if (currentToken._subType === 0) {
      value = stringValue.toUpperCase();
      if (value === const_true || value === const_false) {
        currentToken._subType = 5;
        currentToken._stringValue = value;
        expr = new Expression(4);
        expr.value = value === const_true;
      } else {
        expr = new Expression(8);
        expr.value = stringValue;
      }
    } else if (currentToken._subType === 4) {
      expr = new Expression(2);
      expr.value = parseFloat(stringValue);
      expr.originalValue = stringValue;
    } else if (currentToken._subType === 3) {
      expr = new Expression(3);
      expr.value = stringValue;
    } else if (currentToken._subType === 5) {
      expr = new Expression(4);
      expr.value = stringValue === const_true;
    } else if (currentToken._subType === 6) {
      expr = new Expression(5);
      expr.value = Calc.CalcError.parse(stringValue);
    } else if (currentToken._subType === 7) {
      expr = new Expression(8);
      expr.value = stringValue;
    }
    return { value, expr };
  },
  handleCurrentTokenOneArray(expr, currentTokenIndex, value, arrayRowIndex, tokens, currentToken, valueArray) {
    expr = new Expression(6);
    currentTokenIndex += 1;
    value = [[]];
    arrayRowIndex = 0;
    let arrayColumnCount = 0;
    let currentArrayColumnCount = 0;

    function currentTokenType() {
      return (
        currentToken._type === 0 &&
        (currentToken._subType === 4 ||
          currentToken._subType === 3 ||
          currentToken._subType === 5 ||
          currentToken._subType === 6)
      );
    }

    function currentTokenIndexANDType() {
      return (
        currentTokenIndex < tokens.length - 1 &&
        currentToken._type === 4 &&
        currentToken._stringValue === '-' &&
        tokens[currentTokenIndex + 1]._subType === 4
      );
    }

    while (currentTokenIndex < tokens.length && tokens[currentTokenIndex]._subType !== 2) {
      currentToken = tokens[currentTokenIndex];
      if (currentTokenIndexANDType()) {
        currentTokenIndex += 1;
        currentToken = tokens[currentTokenIndex];
        valueArray.unshift('-');
        currentToken._stringValue = `-${currentToken._stringValue}`;
      }
      if (currentToken._type === 3) {
        if (currentToken._stringValue === arrayGroupSeparator) {
          if (arrayColumnCount !== currentArrayColumnCount) {
            throw 'Invalid arrayColumns';
          }
          value.push([]);
          arrayRowIndex += 1;
          currentArrayColumnCount = 0;
        }
      } else if (currentTokenType()) {
        let tokenValue = currentToken._stringValue;
        if (currentToken._subType === 4) {
          tokenValue = parseFloat(tokenValue);
        } else if (currentToken._subType === 5) {
          tokenValue = tokenValue.toUpperCase() === 'TRUE';
        } else if (currentToken._subType === 6) {
          tokenValue = Calc.CalcError.parse(tokenValue);
        }
        value[arrayRowIndex].push(tokenValue);
        arrayRowIndex === 0 && (arrayColumnCount += 1);
        currentArrayColumnCount += 1;
      } else {
        throw 'Invalid array';
      }
      currentTokenIndex += 1;
    }
    if (arrayColumnCount !== currentArrayColumnCount) {
      throw 'Invalid arrayColumns';
    }
    currentTokenIndex += 1;
    expr.value = new CalcArray(value);
    return { expr, currentTokenIndex, value, currentToken };
  },
  currentTokenBtweenFourToSix(currentTokenType) {
    return currentTokenType === 4 || currentTokenType === 6 || currentTokenType === 5;
  },
  resolveToken2(context, parser, tokens, currentTokenIndex) {
    let currentToken = tokens[currentTokenIndex];
    let stringValue = currentToken._stringValue;
    const valueArray = currentToken._value;
    let expr;
    let arrayRowIndex;
    const currentTokenType = currentToken._type;
    const source = null;
    let value;
    let subResult;

    if (currentTokenType === 0) {
      const __ret = this.handleCurrentTokenTypeZero(currentToken, value, stringValue, expr);
      value = __ret.value;
      expr = __ret.expr;
    } else if (currentTokenType === 1) {
      if (stringValue === const_array) {
        const __ret = this.handleCurrentTokenOneArray(
          expr,
          currentTokenIndex,
          value,
          arrayRowIndex,
          tokens,
          currentToken,
          valueArray,
        );
        expr = __ret.expr;
        currentTokenIndex = __ret.currentTokenIndex;
        value = __ret.value;
        currentToken = __ret.currentToken;
        return { expr, index: currentTokenIndex };
      }
      if (valueArray.length > 0) {
        if (valueArray[0] === '@') {
          currentToken._stringValue = valueArray.slice(1).join('');
          stringValue = currentToken._stringValue;
        }
        expr = new Expression(7);
        expr.functionName = stringValue;
        expr.function = this.getFunction(expr.functionName) || Functions.findGlobalFunction(expr.functionName);
        subResult = parser.resolveSubTokens(context, tokens, currentTokenIndex + 1);
        if (subResult) {
          expr.arguments = subResult.exprs;
          return { expr, index: subResult.index };
        }
        expr.arguments = [];
        return expr;
      }
    } else if (this.currentTokenBtweenFourToSix(currentTokenType)) {
      expr = createOperatorExpression(
        currentTokenType === 4 ? preOperaterTypesMap[stringValue] : operaterTypesMap[stringValue],
        stringValue,
      );
    } else if (currentTokenType === 2) {
      expr = new Expression(10);
      subResult = this.resolveSubTokens(context, tokens, currentTokenIndex + 1);
      if (subResult) {
        expr.value = subResult.exprs;
        return { expr, index: subResult.index };
      }
      // throwParseError();
    } else if (currentTokenType === 3) {
      expr = new Expression(0);
      expr.value = stringValue;
    }

    if (source && expr) {
      expr.source = source;
      expr = { expr, index: currentTokenIndex + 1 };
    }

    return expr;
  },
  getFunction(name) {
    if (!name) {
      return;
    }
    let fn = new Functions.Function(name, 0, 255);
    switch (name) {
      case 'BOUND':
        fn.evaluate = BOUND;
        break;
      case 'LISTORDER':
        fn.evaluate = LISTORDER;
        fn.isContextSensitive = function () {
          return true;
        };
        break;
      case 'A':
        fn.evaluate = CONVERTANGLE;
        break;
      case 'C':
        fn.evaluate = GETCENTER;
        break;
      case 'P':
        fn.evaluate = GETPOINT;
        break;
      default:
        fn = void 0;
        break;
    }
    if (fn) {
      fn.minArgs = fn.maxArgs = fn.length;
    }
    return fn;
  },
};

var FormulaToken = (function () {
  function FormulaToken(value, type, index, endIndex, subType) {
    subType = subType || 0;
    const self = this;
    self._value = value;
    let stringValue = Array.isArray(value) ? value.join('') : value;
    self._type = type;
    self._index = index;
    self._endIndex = endIndex || index + value.length - 1;
    if (type === 0 && subType === 0 && value) {
      const lowValue = stringValue.toUpperCase();
      if (lowValue === const_true || lowValue === const_false) {
        subType = 5;

        stringValue = lowValue;
      }
    } else if (type === 1 && stringValue !== const_array) {
      stringValue = stringValue.toUpperCase();
    }
    self._stringValue = stringValue;
    self._subType = subType;
    self._children = [];

    self.type = function () {
      return self._type;
    };

    self.subType = function () {
      return self._subType;
    };

    self.stringValue = function () {
      return self._stringValue;
    };
  }

  return FormulaToken;
})();

// 以下均为减少processArgType圈复杂度而产生的分割函数
function checkArgType4toArray(argValue, argLimitValue) {
  return _toArray(
    argValue,
    argLimitValue._valueType,
    argLimitValue._toOneDimension || false,
    argLimitValue._breakOnError || false,
    argLimitValue._breakOnConvertError || false,
    argLimitValue._ignoreBlank,
    argLimitValue._followFormatter,
  );
}
function checkArgType4retValue(retValue, isExecuteFunc) {
  if (retValue.isError) {
    [retValue] = retValue;
    isExecuteFunc = false;
  }
  if (retValue.isConvertError) {
    retValue = CalcErrorsValue;
    isExecuteFunc = false;
  }
  return {
    retValue,
    isExecuteFunc,
  };
}
function handleArgType5(argLimitValue, retValue, isExecuteFunc) {
  if (argLimitValue._acceptsEmptyString && retValue === '') {
    retValue = CalcErrorsValue;
    isExecuteFunc = false;
  }
  return { retValue, isExecuteFunc };
}
function handleArgType6(argValue, retValue, isExecuteFunc, dateValue) {
  if (_tryToDateTime(argValue, dateValue)) {
    retValue = dateValue.value;
  } else {
    retValue = CalcErrorsValue;
    isExecuteFunc = false;
  }
  return { retValue, isExecuteFunc };
}
function handleArgType8(retValue, isExecuteFunc, complexCondition) {
  if (!retValue || (complexCondition && retValue._getReal() === 0 && retValue._getImag() === 0)) {
    retValue = Calc.Errors.Number;
    isExecuteFunc = false;
  } else {
    retValue = { _real: retValue._getReal(), _imag: retValue._getImag() };
  }
  return { retValue, isExecuteFunc };
}

function processArgType(argValue, argLimitValue) {
  let isExecuteFunc = true;
  let retValue;
  let needNumber;
  if (argLimitValue._argType === 0) {
    // retValue = _toDouble(argValue);
    retValue = argValue;
    needNumber = true;
  } else if (argLimitValue._argType === 1) {
    retValue = parseFloat(argValue);
    needNumber = true;
  } else if (argLimitValue._argType === 2) {
    retValue = _toInt(argValue);
    needNumber = true;
  } else if (argLimitValue._argType === 3) {
    retValue = parseInt(argValue);
    needNumber = true;
  } else if (argLimitValue._argType === 4) {
    retValue = checkArgType4toArray(argValue, argLimitValue);
    ({ retValue, isExecuteFunc } = checkArgType4retValue(retValue));
  } else if (argLimitValue._argType === 5) {
    retValue = _toString(argValue);
    ({ retValue, isExecuteFunc } = handleArgType5(argLimitValue, retValue, isExecuteFunc));
  } else if (argLimitValue._argType === 6) {
    var dateValue = { value: keyword_null };
    ({ retValue, isExecuteFunc } = handleArgType6(argValue, retValue, isExecuteFunc, dateValue));
  } else if (argLimitValue._argType === 7) {
    retValue = _toBool(argValue);
  } else if (argLimitValue._argType === 8) {
    retValue = convertToComplex(argValue);
    ({ retValue, isExecuteFunc } = handleArgType8(retValue, isExecuteFunc, argLimitValue._complexCondition));
  } else {
    retValue = argValue;
  }
  if (needNumber && isNaN(retValue)) {
    retValue = CalcErrorsValue;
    isExecuteFunc = false;
  }
  return { _retValue: retValue, _isExecuteFunc: isExecuteFunc };
}
function judgeSignArgvalue(sign, argValue, num) {
  return (
    (sign === '<' && argValue < num) ||
    (sign === '>' && argValue > num) ||
    (sign === '<=' && argValue <= num) ||
    (sign === '>=' && argValue >= num) ||
    (sign === '=' && argValue === num) ||
    (sign === '!=' && argValue !== num) ||
    (sign === 'checkLength' && argValue.length > num)
  );
}

function processArgCondition(result, argCondition, conditionErrorValue) {
  if (!Array.isArray(argCondition)) {
    argCondition = [argCondition];
  }
  const argValue = result._retValue;
  for (let i = 0; i < argCondition.length; i++) {
    const argConditionArray = argCondition[i].split(' ');
    const sign = argConditionArray[0];
    const num = parseInt(argConditionArray[1]);
    if (judgeSignArgvalue(sign, argValue, num)) {
      result._retValue = conditionErrorValue === keyword_undefined ? Calc.Errors.Number : conditionErrorValue;
      result._isExecuteFunc = false;
      return;
    }
  }
}
function processBuiltInFunctionArgs(args, fnArgsLimit) {
  let argsLimit = [];
  let result;
  let i;
  if (!fnArgsLimit) {
    return { _args: args, _isExecuteFunc: true };
  }
  if (fnArgsLimit._isAllArgsSameLimit) {
    for (let j = 0; j < args.length; j++) {
      argsLimit.push(fnArgsLimit);
    }
  } else if (!Array.isArray(fnArgsLimit)) {
    argsLimit = [fnArgsLimit];
  } else {
    argsLimit = fnArgsLimit;
  }
  for (i = 0; i < argsLimit.length; i++) {
    const argLimitValue = argsLimit[i];
    if (argLimitValue._acceptsRealValue && !args[i]) {
      throw 'Argument Null Exception';
    }
    const isArgExists = args[i] !== keyword_undefined;
    if (!isArgExists) {
      args[i] = argLimitValue._needArgExistsValue
        ? { _isArgExists: isArgExists, _value: argLimitValue._defaultValue }
        : argLimitValue._defaultValue;
      continue;
    }
    result = processArgType(args[i], argLimitValue);
    argLimitValue._argCondition &&
      processArgCondition(result, argLimitValue._argCondition, argLimitValue._conditionErrorValue);
    if (!result._isExecuteFunc) {
      break;
    }
    args[i] = argLimitValue._needArgExistsValue
      ? { _isArgExists: isArgExists, _value: result._retValue }
      : result._retValue;
  }
  if (result) {
    return { _args: args, _isExecuteFunc: result._isExecuteFunc, _result: result._retValue };
  }
}

var createOperatorExpression = function (operatorType, value, value2) {
  const expr = new Expression(9);
  expr.operatorType = operatorType;
  expr.value = value;
  expr.value2 = value2;
  return expr;
};
function defineProperty(obj, prop, descriptor) {
  descriptor.configurable = true;
  descriptor.enumerable = true;
  Object.defineProperty(obj, prop, descriptor);
}

function setRectSize(rect) {
  rect.width = rect.right - rect.left;
  rect.height = rect.bottom - rect.top;
}
function setValueToObject(node, path, value) {
  const t = path.split('.');
  let n = node;
  for (var i = 0, len = t.length; i < len - 1; i++) {
    const k = t[i];
    if (!n[k]) {
      n[k] = {};
    }
    n = n[k];
  }
  n[t[len - 1]] = value;
}

// = ====================核心类PropertySource===================================
const PropertySource = {
  createNew(model) {
    const self = this;
    self.model = model;
    self.parser_ = Parser;
    self.parser_.initFound();
    self.evaluator_ = Evaluator;
    self.context = null;
    self.store_ = {};
    self.defination = {};
    return self;
  },
  getContext(id) {
    const self = this;
    if (id && id.length > 0) {
      return new PropertyContext(self, id);
    }
    return self.context_;
  },
  getCurrentObjectId() {
    return this.objectId_;
  },
  setValueOrFormula(id, path, value) {
    const model = this;
    if (value && value[0] === '=') {
      model.setFormula(id, path, value.substring(1));
    } else {
      model.setValue(id, path, value);
    }
  },
  getValue(id, path) {
    return this.getNodeValue(id, path);
  },
  getNodeValue(id, path) {
    const n = this.getNode(id, path);
    return n && n.value;
  },
  setObject(id, path, options) {
    if (!options) {
      return;
    }
    const model = this;
    let p;
    model.setCurrentObjectId(id);
    const pathLength = path.length;
    for (const k in options) {
      if (options.hasOwnProperty(k)) {
        const v = options[k];
        if (typeof v !== 'object') {
          p = pathLength > 0 ? path + k : k;
          model.setValueOrFormula(id, p, v);
        } else if (v instanceof Expression) {
          p = pathLength > 0 ? path + k : k;
          model.setExpression(id, p, v);
        } else {
          p = pathLength > 0 ? `${path + k}.` : `${k}.`;
          model.setObject(id, p, v);
        }
      }
    }
    if (Array.isArray(options)) {
      model.setValue(id, `${path}isArray`, true);
    }
  },
  getValuesForObject(id, path, formula) {
    const self = this;
    self.setCurrentObjectId(id);
    const t = {};
    const pn = self.store_[id];
    if (pn) {
      t.id = id;
      for (const k in pn) {
        if (pn.hasOwnProperty(k) && (!path || k.indexOf(path) >= 0)) {
          self.ensureObjects(id, t, k);
          let v = formula ? self.getFormula(id, k) : null;
          if (!v) {
            v = self.getValue(id, k);
          }
          if (v !== undefined) {
            setValueToObject(t, k, v);
          }
        }
      }
    }

    return t;
  },
  ensureObjects(id, node, path) {
    let n = node;
    const ps = path.split('.');
    let p = '';
    for (let i = 0; i < ps.length - 1; i++) {
      const key = ps[i];
      p += key;
      if (!n[key]) {
        const isArray = this.getValue(id, `${p}.isArray`);
        if (isArray) {
          n[key] = [];
        } else {
          n[key] = {};
        }
      }
      p += '.';
      n = n[key];
    }
  },
  setCurrentObjectId(id) {
    this.objectId_ = id;
  },
  removeFormula(id, name) {
    const self = this;
    const n = self.getNode(id, name);
    const calc = n && n.calc;
    if (calc) {
      delete calc.expression;
      delete calc.formula;
    }
  },

  getCalcObj(id, path, create) {
    const self = this;
    const n = self.getNode(id, path, create);
    let calc = n && n.calc;
    if (!calc && create) {
      calc = n.calc = new PathCalc(self, id, path);
    }
    return calc;
  },

  getNode(id, path, create) {
    const self = this;
    let pn = self.store_[id];
    if (!pn && create) {
      pn = self.store_[id] = {};
    }

    let node = pn && pn[path];
    if (!node && create) {
      node = pn[path] = {};
    }
    return node;
  },

  setValue(id, path, value) {
    const self = this;
    const node = self.getNode(id, path);
    let old;
    let calc;
    if (node) {
      old = node.value;
      calc = node.calc;
    }

    if ((calc && calc.formula) || old !== value) {
      self.setCurrentObjectId(id);
      self.removeFormula(id, path);
      self.setNodeValue(id, path, value);
      self.calculate(id, path);
    }
  },

  setFormula(id, path, formula) {
    // forceRecalc
    const self = this;
    let t = formula;
    if (t && t[0] !== '=') {
      t = `=${t}`;
    }

    self.removeFormula(id, path);

    if (formula && formula.length > 0) {
      if (formula[0] === '=') {
        formula = formula.substring(1);
      }
      const expression = Parser.parse(self.context, formula);
      if (expression) {
        self.setExpression(id, path, expression);
      }
    }
  },
  getFormula(id, path) {
    const f = this.getCalcObj(id, path);
    if (f && f.formula) {
      return `=${f.formula}`;
    }
  },

  unparseFormula(expr) {
    return Parser.unparse(self.context, expr);
  },

  setExpression(id, name, expression) {
    const self = this;

    self.removeFormula(id, name);

    if (!expression) {
      return null;
    }

    const formula = self.unparseFormula(expression);
    const calcObj = self.getCalcObj(id, name, true);

    calcObj.formula = formula;
    calcObj.expression = expression;
    calcObj.isCalculating = false;

    self.calculate(id, name);
  },

  calculate(id, name) {
    const self = this;
    if (self.calcSuspended) {
      return;
    }
    const calcObj = self.getCalcObj(id, name);
    if (calcObj) {
      const { expression } = calcObj;
      if (expression) {
        const context = self.getContext(id);
        const result = Evaluator.evaluate(expression, context);
        self.setNodeValue(id, name, result, true);
      }
    }
  },

  setNodeValue(id, path, value) {
    // isFormula
    const self = this;
    const n = self.getNode(id, path, true);
    n.value = value;
    // if (self.changed) {
    //     self.changed(id, path, value, old, isFormula);
    // }
  },

  defineProperties() {
    const self = this;

    shapeProperties.forEach((p) => {
      defineProperty(self, p, {
        get() {
          if (self.service) {
            let v = self.service.getValue(self.id, p);
            if (v === keyword_undefined && self.parentShapeID) {
              v = self.service.getValue(self.parentShapeID, p);
            }
            return v;
          }
          return self.model[p];
        },
        set(value) {
          setShapeProperty(self, self.id, p, value);
        },
      });
    });

    defineProperty(self, 'path', {
      get() {
        if (self.pathCache) {
          return self.pathCache;
        }

        let paths;
        if (self.service) {
          paths = self.service.getPath(self.id);
        } else {
          paths = self.model.path;
        }
        const result =
          paths &&
          paths.map((item) => {
            const path = new Path();
            path.pathCommands = item;
            const { fillMode } = item;
            if (fillMode) {
              path.fillMode = fillMode;
            }
            if (item.strokeMode) {
              path.strokeMode = item.strokeMode;
            }
            return path;
          });
        self.pathCache = result;
        return result;
      },
      set(value) {
        delete self.pathCache;
        if (!value) {
          return;
        }
        const p = value.pathCommands || value;
        if (self.service) {
          self.service.setPath(self.id, p);
        } else {
          self.model.path = p;
        }
      },
    });

    defineProperty(self, 'options', {
      get() {
        if (self.optionsCache) {
          return self.optionsCache;
        }
        let p;
        let t = extend && extend({}, defaultOptions);
        if (self.service) {
          p = self.service.getOptions(self.id);
          if (self.parentShapeID) {
            const pOptions = self.service.getOptions(self.parentShapeID);
            t = composite(t, pOptions);
          }
          p = self.optionsCache = composite(t, p);
          return p;
        }
        p = self.model.options;
        p = self.optionsCache = composite(t, p);
        return p;
      },
      set(value) {
        delete self.optionsCache;
        if (self.service) {
          self.service.setOptions(self.id, value);
        } else {
          self.model.options = value;
        }
      },
    });

    defineProperty(self, 'controls', {
      get() {
        if (self.service) {
          return self.service.getControls(self.id);
        }
        return self.model.controls;
      },
      set(value) {
        if (self.service) {
          self.service.setControls(self.id, value);
        } else {
          self.model.controls = value;
        }
      },
    });

    defineProperty(self, 'connectionPoints', {
      get() {
        if (self.service) {
          return self.service.getConnectionPoints(self.id);
        }
        return self.model.connectionPoints;
      },
      set(value) {
        if (self.service) {
          self.service.setConnectionPoints(self.id, value);
        } else {
          self.model.connectionPoints = value;
        }
      },
    });

    defineProperty(self, 'connectionLines', {
      get() {
        if (self.service) {
          return self.service.getConnectionLines(self.id);
        }
        return self.model.connectionLines;
      },
      set(value) {
        if (self.service) {
          self.service.setConnectionLines(self.id, value);
        } else {
          self.model.connectionLines = value;
        }
      },
    });

    defineProperty(self, 'variables', {
      get() {
        if (self.service) {
          const t = self.service.getValues(self.id, 'variables');
          return t && t.variables;
        }
        return self.model.variables;
      },
      set(value) {
        if (self.service) {
          self.service.setValues(self.id, 'variables', value);
        } else {
          self.model.variables = value;
        }
      },
    });

    defineProperty(self, 'textRect', {
      get() {
        if (self.service) {
          const t = self.service.getValues(self.id, 'textRect');
          return t && t.textRect;
        }
        return self.model.textRect;
      },
      set(value) {
        if (self.service) {
          self.service.setValues(self.id, 'textRect', value);
        } else {
          self.model.textRect = value;
        }
      },
    });

    defineProperty(self, 'parent', {
      get() {
        if (self.service) {
          const id = self.service.getValue(self.id, 'parentId');
          return self.service.getShapeById(id);
        }
        return self.model.parentId;
      },
      set(value) {
        if (self.service) {
          self.service.setValueOrFormula(self.id, 'parentId', value ? value.id : keyword_undefined);
        } else {
          self.model.parentId = value ? value.id : keyword_undefined;
        }
      },
    });

    defineProperty(self, 'parentShapeID', {
      get() {
        if (self.service) {
          return self.service.getValue(self.id, 'parentShapeID');
        }
        return self.model.parentShapeID;
      },
      set(value) {
        if (self.service) {
          self.service.setValueOrFormula(self.id, 'parentShapeID', value);
        } else {
          self.model.parentShapeID = value;
        }
      },
    });
  },

  setBounds() {
    const self = this;
    const pathInfo = self.path;
    if (!pathInfo) {
      return;
    }

    const rects = pathInfo.map((path) => path.parseDimensions());
    function getValue(obj) {
      return obj[this.property];
    }
    const bounds = {
      left: Math_min.apply(keyword_null, rects.map(getValue.bind({ property: 'left' }))),
      top: Math_min.apply(keyword_null, rects.map(getValue.bind({ property: 'top' }))),
      right: Math_max.apply(keyword_null, rects.map(getValue.bind({ property: 'right' }))),
      bottom: Math_max.apply(keyword_null, rects.map(getValue.bind({ property: 'bottom' }))),
    };
    setRectSize(bounds);

    self._bounds = bounds;
  },
};

function Path(path) {
  const self = this;
  self.pathCommands = [];
  if (path) {
    self.parse(path);
  }
}

Path.prototype = {
  parse(path) {
    const cmds = path.split(';');
    for (let i = 0, len = cmds.length; i < len; i++) {
      const cmd = cmds[i].trim().split(' ');
      const c = [];
      c.push(cmd[0].trim());

      for (let j = 1, cmdLength = cmd.length; j < cmdLength; j++) {
        if (cmd[j] && cmd[j][0] === '=') {
          c.push(cmd[j]);
        } else {
          c.push(parseFloat(cmd[j]));
        }
      }

      this.pathCommands.push(c);
    }
  },
  moveTo(x, y) {
    const self = this;
    self.pathCommands.push(['M', x, y]);
    return self;
  },
  lineTo(x, y) {
    const self = this;
    self.pathCommands.push(['L', x, y]);
    return self;
  },
  bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y) {
    const self = this;
    self.pathCommands.push(['B', cp1x, cp1y, cp2x, cp2y, x, y]);
    return self;
  },
  quadraticCurveTo(cpx, cpy, x, y) {
    const self = this;
    self.pathCommands.push(['Q', cpx, cpy, x, y]);
    return self;
  },
  arc(x, y, r, startAngle, endAngle) {
    this.pathCommands.push(['A', x, y, r, startAngle, endAngle]);
  },
  arcTo(x1, y1, x2, y2, r) {
    const self = this;
    self.pathCommands.push(['AT', x1, y1, x2, y2, r]);
    return self;
  },
  beginPath() { },
  closePath() {
    const self = this;
    self.pathCommands.push(['Z']);
    return self;
  },
  parseDimensions() {
    const path = this;
    const aX = [];
    const aY = [];
    let current;
    let subpathStartX = 0;
    let subpathStartY = 0;
    let x = 0;
    let y = 0;
    let bounds = [];

    const { pathCommands } = path;

    for (let i = 0, len = pathCommands.length; i < len; ++i) {
      current = pathCommands[i];
      const [current0, current1, current2, current3, current4, current5, current6] = current;

      switch (current0) {
        case 'V':
        case 'v':
          y = makeAbsolute(current0, y, current1);
          break;
        case 'H':
        case 'h':
          x = makeAbsolute(current0, x, current1);
          break;
        case 'L':
        case 'l':
          x = makeAbsolute(current0, x, current1);
          y = makeAbsolute(current0, y, current2);

          bounds = [];
          break;

        case 'M':
        case 'm':
          x = makeAbsolute(current0, x, current1);
          y = makeAbsolute(current0, y, current2);

          subpathStartX = x;
          subpathStartY = y;
          bounds = [];
          break;

        case 'B':
        case 'C':
        case 'c':
          var curX = x;
          var curY = y;

          var x0 = makeAbsolute(current0, x, current1);
          var y0 = makeAbsolute(current0, y, current2);

          var x1 = makeAbsolute(current0, x, current3);
          var y1 = makeAbsolute(current0, y, current4);

          x = makeAbsolute(current0, x, current5);
          y = makeAbsolute(current0, y, current6);

          bounds = getBoundsOfCurve(curX, curY, x0, y0, x1, y1, x, y);
          break;

        case 'Q':
        case 'q':
        case 'S':
        case 's':
          curX = x;
          curY = y;

          x0 = makeAbsolute(current0, x, current1);
          y0 = makeAbsolute(current0, y, current2);

          x = makeAbsolute(current0, x, current3);
          y = makeAbsolute(current0, y, current4);

          bounds = getBoundsOfCurve(curX, curY, x0, y0, x0, y0, x, y);
          break;

        case 'AT':
        case 'T':
          x0 = makeAbsolute(current0, x, current1);
          y0 = makeAbsolute(current0, y, current2);

          x = makeAbsolute(current0, x, current3);
          y = makeAbsolute(current0, y, current4);

          bounds.push({ x: x0, y: y0 });
          bounds.push({ x, y });
          break;

        case 'A':
        case 'a':
        case 'E':
        case 'e':
          x = makeAbsolute(current0, x, current1);
          y = makeAbsolute(current0, y, current2);

          bounds.push({ x, y });
          var r = current3;
          var a1 = current4;
          var a2 = current5;

          var { PI } = Math;
          bounds.push({ x: x + r * Math.cos(a1), y: y + r * Math.sin(a1) });
          bounds.push({ x: x + r * Math.cos(a2), y: y + r * Math.sin(a2) });

          if (a1 === 0 || a2 === 2 * PI) {
            bounds.push({ x: x + r, y });
          }
          if (a1 < PI / 2 || a2 > PI / 2) {
            bounds.push({ x, y: y + r });
          }
          if (a1 < PI || a2 > PI) {
            bounds.push({ x: x - r, y });
          }
          if (a1 < PI + PI / 2 || a2 > PI + PI / 2) {
            bounds.push({ x, y: y - r });
          }
          break;

        case 'Z':
        case 'z':
          x = subpathStartX;
          y = subpathStartY;
          break;
      }

      bounds.forEach((point) => {
        aX.push(point.x);
        aY.push(point.y);
      });
      aX.push(x);
      aY.push(y);
    }

    const minX = min(aX) || 0;
    const minY = min(aY) || 0;
    const maxX = max(aX) || 0;
    const maxY = max(aY) || 0;
    const deltaX = maxX - minX;
    const deltaY = maxY - minY;

    return {
      left: minX,
      top: minY,
      right: maxX,
      bottom: maxY,
      width: deltaX,
      height: deltaY,
    };
  },
};

// = ====================核心类Evaluator===================================

var Evaluator = {
  evaluate(expr, context, acceptsArray, acceptsReference) {
    if (!expr) {
      throw 'The argument \'expr\' is null';
    }
    if (expr.type === undefined && expr._expr) {
      expr = expr._expr;
    }
    while (expr.type === 10) {
      expr = expr.value;
    }
    const self = this;
    let result;
    let needExpendIndexs = keyword_null;
    if (expr.type === 12) {
      needExpendIndexs = expr.needExpendIndexs;
      expr = expr.value;
    }

    function callEvaluateByType() {
      let called = false;
      if (expr.type >= 2 && expr.type <= 6) {
        called = true;
        result = self.evaluateConst(expr, context, acceptsArray);
      } else if (expr.type === 1 || expr.type === 13) {
        called = true;
        result = self.evaluateReference(expr, context, acceptsReference, acceptsArray);
      } else if (expr.type === 8) {
        called = true;
        result = self.evaluateName(expr, context, acceptsArray, acceptsReference);
      } else if (expr.type === 9 && !expr.value2) {
        called = true;
        result = self.evaluateUnaryOperation(expr, context, acceptsArray, acceptsReference, needExpendIndexs);
      } else if (expr.type === 9) {
        called = true;
        result = self.evaluateBinaryOperation(expr, context, acceptsArray, acceptsReference, needExpendIndexs);
      } else if (expr.type === 7) {
        called = true;
        result = self.evaluateFunction(expr, context, acceptsArray, acceptsReference, needExpendIndexs);
      } else if (expr.type === 11) {
        called = true;
        result = keyword_undefined;
      }
      return called;
    }
    const called = callEvaluateByType();
    if (!called && context && context.evaluate) {
      return context.evaluate(expr, acceptsArray, acceptsReference);
    }
    return result;
  },
  evaluateConst(expr, context, acceptsArray) {
    const { value } = expr;
    if (Array.isArray(value)) {
      if (acceptsArray || (context && (context.arrayFormulaMode || context._isExpandArrayToMultiCall()))) {
        return value;
      }
      return value.getValue(0, 0);
    }
    return value;
  },
  evaluateReference(expr, context, acceptsReference, acceptsArray) {
    if (!context) {
      return CalcErrorsValue;
    }

    const initEvaluateVariable = () => {
      const source = (expr.type === 13 ? expr.source() : expr.source) || context.source;
      const baseRow = isNaN(context.row) ? 0 : context.row;
      const baseColumn = isNaN(context.column) ? 0 : context.column;
      const pos = expr.getRange && expr.getRange(baseRow, baseColumn);
      return { source, baseRow, baseColumn, pos };
    };

    const { source, baseRow, baseColumn, pos } = initEvaluateVariable();
    if (!pos) {
      return expr.type === 13 ? CalcErrorsValue : CalcErrorsReference;
    }
    let row = pos.row < 0 ? 0 : pos.row;
    let col = pos.col < 0 ? 0 : pos.col;
    const { rowCount } = pos;
    const { colCount } = pos;
    if (acceptsReference || context.arrayFormulaMode) {
      if (expr.endSource) {
        return context.getSheetRangeReference({
          source: expr.source,
          endSource: expr.endSource,
          row,
          col,
          rowCount,
          colCount,
        });
      }
      return context.getReference(source, pos);
    }
    if (acceptsArray && (rowCount > 1 || colCount > 1)) {
      const array = [];
      for (let i = 0; i < rowCount; i++) {
        array[i] = [];
        for (let j = 0; j < colCount; j++) {
          array[i][j] = source.getValue(i + row, j + col);
        }
      }
      return new CalcArray(array);
    }

    const handleRowCountAndColCountGreaterOne = () => {
      let ifCalcErrorsValue = false;
      const rowInRange = baseRow >= pos.row && baseRow < pos.row + rowCount;
      const colInRange = baseColumn >= pos.col && baseColumn < pos.col + colCount;
      if (rowInRange && colInRange) {
        row = baseRow;
        col = baseColumn;
      } else if (!rowInRange && !colInRange) {
        ifCalcErrorsValue = true;
        // return CalcErrorsValue;
      } else if (rowInRange && colCount === 1) {
        row = baseRow;
      } else if (colInRange && rowCount === 1) {
        col = baseColumn;
      } else {
        ifCalcErrorsValue = true;
        // return CalcErrorsValue;
      }
      return ifCalcErrorsValue;
    };

    const judgeColCount = () => {
      let ifRetCalcErrorsValue = false;
      if (rowCount > 1 || colCount > 1) {
        const ifCalcErrorsValue = handleRowCountAndColCountGreaterOne();
        if (ifCalcErrorsValue) {
          ifRetCalcErrorsValue = true;
          // return CalcErrorsValue;
        }
      } else if (pos.row === -1 && rowCount === -1) {
        if (colCount !== 1) {
          ifRetCalcErrorsValue = true;
          // return CalcErrorsValue;
        }
        row = baseRow;
      } else if (pos.col === -1 && colCount === -1) {
        if (rowCount !== 1) {
          ifRetCalcErrorsValue = true;
          // return CalcErrorsValue;
        }
        col = baseColumn;
      }
      return ifRetCalcErrorsValue;
    };

    const ifRetCalcErrorsValue = judgeColCount();
    if (ifRetCalcErrorsValue) {
      return CalcErrorsValue;
    }
    return source.getValue(row, col);
  },
  evaluateName(expr, context, acceptsArray, acceptsReference) {
    if (!context) {
      return CalcErrorsName;
    }
    let source;
    if (expr.source) {
      source = expr.source;
      context = source.getEvaluatorContext(context.identity, context.arrayFormulaMode, context.arrayIdentity);
    }
    const sub = context.getName(expr.value);
    if (!sub) {
      return CalcErrorsName;
    }
    return this.evaluate(sub, context, acceptsArray, acceptsReference);
  },
  evaluateUnaryOperation(expr, context, acceptsArray, acceptsReference, needExpendIndexs) {
    let acceptsReferences = false;
    if (needExpendIndexs && needExpendIndexs.length > 0) {
      acceptsArray = true;
      acceptsReferences = true;
    }

    const arg = this.evaluate(expr.value, context, acceptsArray, acceptsReferences);
    if (isCalcError(arg)) {
      return arg;
    }
    if (arg === 11) {
      // missingArgument
      return CalcErrorsNotAvailable;
    }
    return this.evaluateWithArgs(
      expr,
      (args1) => evaluateOperator(expr.operatorType, args1[0]),
      context,
      needExpendIndexs,
      [arg],
      acceptsArray,
      acceptsReference,
    );
  },
  evaluateBinaryOperation(expr, context, acceptsArray, acceptsReference, needExpendIndexs) {
    const acceptsArrays = [acceptsArray, acceptsArray];
    const operatorAcceptsReference = expr.operatorType >= 15;
    const acceptsReferences = [operatorAcceptsReference, operatorAcceptsReference];
    if (needExpendIndexs && needExpendIndexs.length > 0) {
      for (var i = 0; i < needExpendIndexs.length; i++) {
        acceptsArrays[needExpendIndexs[i]] = true;
        acceptsReferences[needExpendIndexs[i]] = true;
      }
    }

    const sub = [expr.value, expr.value2];
    const args = [];
    for (i = 0; i < 2; i++) {
      const arg = this.evaluate(sub[i], context, acceptsArrays[i], acceptsReferences[i]);
      if (isCalcError(arg)) {
        return arg;
      }
      // if (arg === 11) { //Calc.missingArgument
      //     return 'CalcErrorsNotAvailable4';
      // }
      args[i] = arg;
    }
    return this.evaluateWithArgs(
      expr,
      (args1) => evaluateOperator(expr.operatorType, args1[0], args1[1]),
      context,
      needExpendIndexs,
      args,
      acceptsArray,
      acceptsReference,
    );
  },

  startCache() {
    this._functionResultCaches = {};
    this.service._hasAsync && this.asyncManager.startCalc();
  },
  endCache() {
    this._functionResultCaches = keyword_null;
  },
  isReference(value) {
    return value instanceof CalcReference;
  },
  evaluateFunction(expr, context, acceptsArray, acceptsReference, needExpendIndexs) {
    if (!expr || !expr.function || typeof expr.function === 'string') {
      return CalcErrorsName;
    }
    const argCount = expr.arguments.length;
    const self = this;
    const asyncCount = null;
    const fn = expr.function;
    let args;
    let arg;
    let getReferenceValues = keyword_null;
    if (fn instanceof AsyncFunction) {
      this.asyncManager.startCalcFunction(fn, expr.arguments, context);
    }

    function judgeArgs(i) {
      function arrayGetCount(array) {
        return array && array.getRowCount() === 1 && array.getColumnCount() === 1;
      }

      function referenceGetCount(reference) {
        return reference && reference.getRowCount(0) === 1 && reference.getColumnCount(0) === 1;
      }

      if ((!fn.acceptsArray(i) && Array.isArray(arg)) || (!fn.acceptsReference(i) && this.isReference(arg))) {
        const array = Array.isArray(arg) ? arg : keyword_null;
        const reference = this.isReference(arg) ? arg : keyword_null;
        if (arrayGetCount(array)) {
          arg = array.getValue(0, 0);
        } else if (referenceGetCount(reference)) {
          arg = reference.getValue(0, 0, 0);
        } else {
          const list = [];
          let contains = false;
          if (needExpendIndexs) {
            for (let j = 0; j < needExpendIndexs.length; j++) {
              list.push(needExpendIndexs[j]);
              if (needExpendIndexs[j] === i) {
                contains = true;
              }
            }
          }
          if (!contains) {
            list.push(i);
            needExpendIndexs = list;
          }
        }
      }
    }

    function handleArgCountGreaterThanZero() {
      args = [];
      const acceptsArrays = [];
      const acceptsReferences = [];
      let ifArgRet = false;
      for (var i = 0; i < argCount; i++) {
        acceptsArrays[i] = fn.acceptsArray(i);
        acceptsReferences[i] = fn.acceptsReference(i);
      }
      if (needExpendIndexs && needExpendIndexs.length > 0) {
        getReferenceValues = [];
        for (i = 0; i < argCount; i++) {
          getReferenceValues[i] = true;
        }
        for (i = 0; i < needExpendIndexs.length; i++) {
          const argIndex = needExpendIndexs[i];
          acceptsArrays[argIndex] = true;
          acceptsReferences[argIndex] = true;

          getReferenceValues[argIndex] = !(fn.acceptsReference(argIndex) && !fn.acceptsArray(argIndex));
        }
      }

      let testArgValue;
      const testArg = -1;
      const branchArgument = -1;

      for (i = 0; i < argCount; i++) {
        if (testArg === i) {
          arg = testArgValue;
        } else if (branchArgument >= 0 && i !== branchArgument) {
          args[i] = null;
          continue;
        } else {
          arg = self.evaluate(expr.arguments[i], context, acceptsArrays[i], acceptsReferences[i]);
        }
        judgeArgs.call(self, i);
        if (isCalcError(arg) && !fn.acceptsError(i)) {
          ifArgRet = true;
        }
        if (arg === 'missingArgument' && !fn.acceptsMissingArgument(i)) {
          arg = keyword_null;
        }

        args[i] = arg;
      }
      return { ifArgRet, arg };
    }
    function evaluateWithArgsCallback(args1, expression, isItemInArray) {
      const retValue = processBuiltInFunctionArgs(args1, fn._argsLimit);
      args1 = retValue._args;
      if (fn.isContextSensitive()) {
        context.acceptsReference = acceptsReference || context._isExpandArrayToMultiCall();
        if (fn instanceof AsyncFunction) {
          self._ayncFunctionResultCaches = self._ayncFunctionResultCaches || {};
          return fn.evaluateWhenArgumentsIsSame()
            ? self.evaluateAsyncFunction(context, expression, fn, asyncCount, args1, isItemInArray)
            : self.evaluateWithCache(
              fn,
              args1,
              () => self.evaluateAsyncFunction(context, expression, fn, asyncCount, args1, isItemInArray),
              self._ayncFunctionResultCaches,
            );
        }
        return fn.evaluateWithContext(context, args1);
      }
      const isArrayFormula = context.arrayFormulaMode;
      if (isArrayFormula) {
        fn._offsetIdentity = {
          row: context.rowOffset,
          col: context.columnOffset,
        };
      }
      const evluateFunc = function () {
        return retValue._isExecuteFunc ? fn.evaluate.apply(fn, args1) : retValue._result;
      };
      const value = isArrayFormula
        ? self.evaluateWithCache(fn, args1, evluateFunc, self._functionResultCaches)
        : evluateFunc();
      delete fn._offsetIdentity;
      return value;
    }
    if (argCount === 0) {
      args = [];
    } else {
      const __ret = handleArgCountGreaterThanZero();
      if (__ret.ifArgRet) {
        return __ret.arg;
      }
    }
    return self.evaluateWithArgs(
      expr,
      evaluateWithArgsCallback,
      context,
      needExpendIndexs,
      args,
      acceptsArray,
      acceptsReference,
      getReferenceValues,
    );
  },

  evaluateAsyncFunction(context, expr, fn, asyncCount, args1, isItemInArray) {
    const node = this.asyncManager.getNode();
    let result;
    if (node._hasResult) {
      result = node._result;
    } else if (!node.canEvaluate()) {
      result = node._result !== keyword_undefined ? node._result : fn.defaultValue();
    } else {
      const aContext = new AsyncEvaluateContext(context, node);
      result = fn.evaluateWithContext(aContext, args1);
      if (aContext.notAsync) {
        return result;
      }
      if (result === keyword_undefined) {
        if (node._result !== keyword_undefined) {
          result = node._result;
        } else {
          result = fn.defaultValue();
        }
      } else if (node.evaluateMode === 1) {
        node._hasResult = true;
      }
    }
    node._result = result;
    if (!isItemInArray) {
      this.asyncManager.endCalcFunction();
    }
    return result;
  },
  evaluateWithCache(fn, args1, evaluateFunction, functionCaches) {
    function handleEvaluateCacheFunctionsInfoArgsEqualLength(functionInfo, cached) {
      for (let argIndex = 0; argIndex < args1.length; argIndex++) {
        const cacheArg = functionInfo.args[argIndex];
        const newArg = args1[argIndex];
        if (cacheArg === newArg) {
          continue;
        }
        if (cacheArg instanceof CalcReference && newArg instanceof CalcReference) {
          const rangeCount = cacheArg._rangeCount;
          if (cacheArg._source !== newArg._source || rangeCount !== newArg._rangeCount) {
            cached = false;
            break;
          }
          for (let rangeIndex = 0; rangeIndex < rangeCount; rangeIndex++) {
            if (
              cacheArg.getRow(rangeIndex) !== newArg.getRow(rangeIndex) ||
              cacheArg.getColumn(rangeIndex) !== newArg.getColumn(rangeIndex) ||
              cacheArg.getRowCount(rangeIndex) !== newArg.getRowCount(rangeIndex) ||
              cacheArg.getColumnCount(rangeIndex) !== newArg.getColumnCount(rangeIndex)
            ) {
              cached = false;
              break;
            }
          }
        } else {
          cached = false;
          break;
        }
      }
      return { cached };
    }

    if (functionCaches) {
      let cached = false;
      var functionInfos = functionCaches[fn.name + args1.length];
      if (functionInfos) {
        for (var i = 0; i < functionInfos.length; i++) {
          const functionInfo = functionInfos[i];
          cached = false;
          if (functionInfo.args.length === args1.length) {
            cached = true;
            const __ret = handleEvaluateCacheFunctionsInfoArgsEqualLength(functionInfo, cached);
            cached = __ret.cached;
            if (cached) {
              cached = false;
            }
          }
          if (cached) {
            functionInfo.flag += 1;
            return functionInfo.value;
          }
        }
      } else {
        functionInfos = functionCaches[fn.name + args1.length] = [];
      }
    }
    const value = evaluateFunction();
    if (functionCaches && value !== keyword_undefined) {
      let { length } = functionInfos;
      if (length >= 100) {
        const tmp = [];
        for (i = 0; i < length; i++) {
          if (functionInfos[i].flag > 0) {
            tmp.push(functionInfos[i]);
          }
        }
        tmp.sort((a, b) => b.flag - a.flag);
        length = Math.min(50, tmp.length);
        functionInfos = tmp.slice(0, length);
        functionCaches[fn.name + args1.length] = functionInfos;
      }
      functionInfos.push({
        args: args1,
        value,
        flag: 0,
        _offsetIdentity: fn._offsetIdentity,
      });
    }
    return value;
  },
  SetAsyncResult(context) {
    const { ctx } = context;
    ctx.source._getCalcServiceInternal().recalculate(ctx.source, context.row, context.col, true);
  },
  evaluateWithArgs(
    expr,
    evaluateDelegate,
    context,
    needExpendIndexs,
    args,
    acceptsArray,
    acceptsReference,
    getReferenceValues,
  ) {
    const handleValueArrayAssign = (expendedArgs) => {
      const valueArray = [];
      var value;
      const rowCount = expendedArgs[0].length;
      const colCount = expendedArgs[0][0].length;
      let ifRetValue = false;
      for (let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
        valueArray[rowIndex] = [];
        for (let colIndex = 0; colIndex < colCount; colIndex++) {
          try {
            const expArgs = [];
            for (let argIndex = 0; argIndex < args.length; argIndex++) {
              expArgs[argIndex] = expendedArgs[argIndex][rowIndex][colIndex];
            }
            value = evaluateDelegate(expArgs, expr, rowIndex + 1 !== rowCount || colIndex + 1 !== colCount);
            if (this.isReference(value)) {
              if (expr.type === 7) {
                const fn = expr.function;
                if (fn.returnReference && fn.returnReference()) {
                  ifRetValue = true;
                  // return value;
                }
              }
              value = this.getOneValue(context, value);
            }
            valueArray[rowIndex][colIndex] = value;
          } catch (InvalidCastException) {
            valueArray[rowIndex][colIndex] = CalcErrorsValue;
          }
        }
      }
      return { valueArray, value, ifRetValue };
    };

    if (needExpendIndexs && needExpendIndexs.length > 0) {
      const expendedArgs = this.expandArgs(context, expr, args, needExpendIndexs, getReferenceValues);
      if (!expendedArgs) {
        return CalcErrorsNotAvailable;
      }
      const __ret = handleValueArrayAssign(expendedArgs);
      if (__ret.ifRetValue) {
        return __ret.value;
      }
      const valueArray = __ret.valueArray;
      var value = __ret.value;
      return new Calc.CalcArray(valueArray);
    }

    const initCheck = (value) => {
      let ifRetValue = false;
      let ifRetCallGetOneValue = false;
      if (context.arrayFormulaMode && context._isExpandArrayToMultiCall()) {
        ifRetValue = true;
        // return value;
      }
      if (Array.isArray(value) && !acceptsArray) {
        ifRetCallGetOneValue = true;
        // return this.getOneValue(context, value);
      }
      return { ifRetValue, ifRetCallGetOneValue };
    };

    try {
      value = evaluateDelegate(args, expr);
      const { ifRetValue, ifRetCallGetOneValue } = initCheck(value);
      if (ifRetValue) {
        return value;
      }
      if (ifRetCallGetOneValue) {
        return this.getOneValue(context, value);
      }
      if (this.isReference(value) && !acceptsReference) {
        const refValue = value;
        if (acceptsArray && refValue.getRangeCount() === 1) {
          const array = [];
          for (let i = 0; i < refValue.getRowCount(0); i++) {
            array[i] = [];
            for (let j = 0; j < refValue.getColumnCount(0); j++) {
              array[i][j] = refValue.getValue(0, i, j);
            }
          }
          return new Calc.CalcArray(array, refValue.getColumnCount(0));
        }
        return this.getOneValue(context, value);
      }
      return value;
    } catch (InvalidCastException) {
      return CalcErrorsValue;
    }
  },
  getOneValue(context, value) {
    let r;
    let c;

    function handleValueAssginBYReference(rouCount, reference, columnCount) {
      if (context.rowOffset !== -1 || context.columnOffset !== -1) {
        if (rouCount === 1) {
          r = 0;
        } else if (context.arrayFormulaMode) {
          r = context.rowOffset;
        } else {
          r = context.rowOffset - reference.getRow(0);
        }
        if (columnCount === 1) {
          c = 0;
        } else if (context.arrayFormulaMode) {
          c = context.columnOffset;
        } else {
          c = context.columnOffset - reference.getColumn(0);
        }
      } else {
        r = rouCount === 1 ? 0 : context.row - reference.getRow(0);
        c = columnCount === 1 ? 0 : context.column - reference.getColumn(0);
      }
      if (r >= rouCount || c >= columnCount) {
        value = CalcErrorsNotAvailable;
      } else {
        value = reference.getValue(0, r, c);
      }
    }

    function handleValueBeArray() {
      const array = value;
      if (context.arrayFormulaMode && (context.rowOffset !== -1 || context.columnOffset !== -1)) {
        r = array.getRowCount() === 1 ? 0 : context.rowOffset;
        c = array.getColumnCount() === 1 ? 0 : context.columnOffset;
        if (r >= array.getRowCount() || c >= array.getColumnCount()) {
          value = CalcErrorsNotAvailable;
        } else {
          value = array.getValue(r, c);
        }
      } else {
        value = array.getValue(0, 0);
      }
    }

    if (this.isReference(value)) {
      const reference = value;
      const rouCount = reference.getRowCount(0);
      const columnCount = reference.getColumnCount(0);
      if (reference.getRangeCount() > 1 || (!context.arrayFormulaMode && rouCount > 1 && columnCount > 1)) {
        value = CalcErrorsValue;
      } else {
        handleValueAssginBYReference(rouCount, reference, columnCount);
      }
    } else if (Array.isArray(value)) {
      handleValueBeArray();
    }
    return this.isReference(value) || Array.isArray(value) ? this.getOneValue(context, value) : value;
  },
  expandArgs(context, expr, args, needExpendIndexs, getReferenceValues) {
    let rowCount = 1;
    let colCount = 1;
    let testArg = -1;
    let expandRow = true;
    let expandColumn = true;
    let array = null;
    let reference = null;
    const self = this;
    let rc = 1;
    let cc = 1;
    const functionExpr = expr.type === 7 ? expr : keyword_null;
    if (functionExpr && !functionExpr.function.expandRows()) {
      expandRow = false;
    }
    if (functionExpr && !functionExpr.function.expandColumns()) {
      expandColumn = false;
    }

    function functionExprJudge() {
      return (
        functionExpr &&
        functionExpr.function.isBranch() &&
        (context.arrayFormulaMode || context._isExpandArrayToMultiCall())
      );
    }

    function argsJJudge(j, indexList) {
      return (
        j !== testArg &&
        Common._ArrayHelper._indexOf(indexList, j) < 0 &&
        (Array.isArray(args[j]) || this.isReference(args[j]))
      );
    }

    function handleFunctionExpr() {
      if (functionExprJudge()) {
        testArg = functionExpr.function.findTestArgument();
        const indexList = [];
        let contains = false;
        if (needExpendIndexs) {
          for (let i = 0; i < needExpendIndexs.length; i++) {
            indexList.push(needExpendIndexs[i]);
            if (needExpendIndexs[i] === testArg) {
              contains = true;
            }
          }
        }
        if (contains || Array.isArray(args[testArg]) || this.isReference(args[testArg])) {
          for (let j = 0; j < functionExpr.arguments.length; j++) {
            if (argsJJudge.call(self, j, indexList)) {
              indexList.push(j);
            }
          }
          needExpendIndexs = indexList;
        }
      }
    }

    handleFunctionExpr.call(self);

    function handleNeedExpendIndexComp() {
      let ifRetKWNull = false;
      for (let k = 0; k < needExpendIndexs.length; k++) {
        const argValue = args[needExpendIndexs[k]];
        array = Array.isArray(argValue) ? argValue : null;
        reference = this.isReference(argValue) ? argValue : null;
        rc = 0;
        cc = 0;
        if (array) {
          rc = array.getRowCount();
          cc = array.getColumnCount();
        } else if (reference) {
          if (reference.getRangeCount() > 1) {
            ifRetKWNull = true;
            // return keyword_null;
          }
          rc = expandRow ? reference.getRowCount(0) : 1;
          cc = expandColumn ? reference.getColumnCount(0) : 1;
        }
        rowCount = rc > rowCount ? rc : rowCount;
        colCount = cc > colCount ? cc : colCount;
      }
      return ifRetKWNull;
    }

    if (handleNeedExpendIndexComp.call(self)) {
      return keyword_null;
    }
    const expArgs = [];
    let expendIndexIndex = 0;
    let expendIndex = needExpendIndexs[expendIndexIndex];

    function handleIndexEqual(value, argIndex) {
      let ifRetKWNull = false;
      array = Array.isArray(value) ? value : keyword_null;
      reference = this.isReference(value) ? value : keyword_null;

      function rcANDccJudge() {
        return (
          ((rc !== 1 && rc !== rowCount) || (cc !== 1 && cc !== colCount)) &&
          (testArg === -1 || argIndex === testArg) &&
          !context.arrayFormulaMode
        );
      }

      if (array || reference) {
        rc = (array && array.getRowCount()) || (expandRow ? reference.getRowCount(0) : 1);
        cc = (array && array.getColumnCount()) || (expandColumn ? reference.getColumnCount(0) : 1);
        if (rcANDccJudge()) {
          ifRetKWNull = true;
          // return keyword_null;
        }
      }
      expendIndexIndex += 1;
      if (expendIndexIndex < needExpendIndexs.length) {
        expendIndex = needExpendIndexs[expendIndexIndex];
      } else {
        expendIndex = -1;
      }
      return ifRetKWNull;
    }

    function ccReturn(cc, colIndex) {
      return cc === 1 ? 0 : colIndex;
    }
    function expArgsAssign(argIndex, value) {
      for (let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
        expArgs[argIndex][rowIndex] = [];
        for (let colIndex = 0; colIndex < colCount; colIndex++) {
          if ((rc !== 1 && rowIndex >= rc) || (cc !== 1 && colIndex >= cc)) {
            expArgs[argIndex][rowIndex][colIndex] = CalcErrorsNotAvailable;
          } else if (array) {
            expArgs[argIndex][rowIndex][colIndex] = array.getValue(rc === 1 ? 0 : rowIndex, ccReturn(cc, colIndex));
          } else if (reference) {
            if (!getReferenceValues || getReferenceValues[argIndex]) {
              expArgs[argIndex][rowIndex][colIndex] = reference.getValue(
                0,
                rc === 1 ? 0 : rowIndex,
                ccReturn(cc, colIndex),
              );
            } else {
              expArgs[argIndex][rowIndex][colIndex] = reference.create([
                createRange(
                  reference.getRow(0) + (rc === 1 ? 0 : rowIndex),
                  reference.getColumn(0) + ccReturn(cc, colIndex),
                  1,
                  1,
                ),
              ]);
            }
          } else {
            expArgs[argIndex][rowIndex][colIndex] = value;
          }
        }
      }
    }

    for (let argIndex = 0; argIndex < args.length; argIndex++) {
      expArgs[argIndex] = [];
      const value = args[argIndex];
      array = keyword_null;
      reference = keyword_null;
      rc = cc = 1;
      if (argIndex === expendIndex || getReferenceValues === keyword_undefined) {
        const ifRetKWNull = handleIndexEqual.call(self, value, argIndex);
        if (ifRetKWNull) {
          return keyword_null;
        }
      }
      if (reference) {
        const sRow = reference.getRow(0);
        const sCol = reference.getColumn(0);
        rowCount = sRow + rowCount - sRow;
        colCount = sCol + colCount - sCol;
      }
      expArgsAssign(argIndex, value);
    }
    return expArgs;
  },
};
function rotatePoint(point, origin, radians) {
  point.x -= origin.x;
  point.y -= origin.y;
  const v = rotateVector(point, radians);

  return { x: v.x + origin.x, y: v.y + origin.y };
}

function rotateVector(vector, radians) {
  const sin = Math.sin(radians);
  const cos = Math.cos(radians);
  const rx = vector.x * cos - vector.y * sin;
  const ry = vector.x * sin + vector.y * cos;
  return {
    x: rx,
    y: ry,
  };
}
function toRadius() {
  // return (angle / 180) * Math.PI;
  // todo
  return 0;
}
var tryExtractToSingleValue = function (arg) {
  let success = true;
  if (arg && arg.getValue) {
    const array = _toArray(arg, 0, false, true);
    if (array.isError) {
      arg = array[0];
    } else if (array.rowCount === 1 && array.colCount === 1) {
      arg = array[0][0];
    } else {
      arg = array;
      success = false;
    }
  }
  return {
    value: arg,
    success,
  };
};
var evaluateOperator = function (operatorType, value1, value2) {
  return evaluateMathOperator(operatorType, value1, value2);
};

function _tryToDoubleSeparatorJudge(value, decimalSeparator, groupSeparator) {
  return (
    (decimalSeparator !== '.' && groupSeparator !== '.' && value.indexOf('.') >= 0) ||
    (decimalSeparator !== ',' && groupSeparator !== ',' && value.indexOf(',') >= 0)
  );
}

function _tryToDoubleValueJudge(value, decimalSeparator) {
  return (
    value[0] === '$' ||
    value[value.length - 1] === '$' ||
    value.indexOf(decimalSeparator) !== value.lastIndexOf(decimalSeparator) ||
    (value.length >= 2 && value[0] === '0' && value[1] === 'x')
  );
}

function _tryToDoubleNaNOrPercent(result, value, isPercent) {
  if (_isNaNOrInfinite(result)) {
    let c = value.charCodeAt(0);
    c |= 0x20;
    if (value.length > 4 && c >= 96 && c <= 122) {
      let s = value[0] + value[1] + value[2];
      s = s.toUpperCase();
      if (!monthStrings[s]) {
        return { ret: true };
      }
    }

    if (value[0] === '/' || value[value.length - 1] === '/') {
      return { ret: true };
    }

    if (value[0] === '#' || value[value.length - 1] === '#') {
      return { ret: true };
    }

    result = new Date(value);
    if (_isNaNOrInfinite(result.valueOf())) {
      return { ret: true };
    }
    result = dateTimeHelper._toOADate(result);
  }
  if (isPercent) {
    result /= 100;
  }
  return { result, ret: false };
}
function _tryToDoubleTypestrBranchJudge(typestr, value) {
  let result;
  let ret = false;
  if (typestr === const_number) {
    result = value;
  } else if (typestr === const_boolean) {
    result = value ? 1 : 0;
  } else if (value instanceof Date) {
    result = dateTimeHelper._toOADate(value);
  } else {
    ret = true;
  }
  return { result, ret };
}
function _tryToDouble(value, doubleValue) {
  let result = keyword_null;
  if (!value) {
    doubleValue.value = 0;
    return true;
  }
  const typestr = typeof value;
  try {
    if (typestr === const_string) {
      value = value.trim();
      if (value.length === 0) {
        doubleValue.value = 0;
        return true;
      }
      const decimalSeparator = numberDecimalSeparator;
      const groupSeparator = numberGroupSeparator;
      if (_tryToDoubleSeparatorJudge(value, decimalSeparator, groupSeparator)) {
        return false;
      }

      let isPercent = false;
      if (value.charAt(value.length - 1) === '%') {
        isPercent = true;
        value = value.substr(0, value.length - 1);
      }
      result = Number(value).valueOf();
      if (_tryToDoubleValueJudge(value, decimalSeparator)) {
        return false;
      }

      const res = _tryToDoubleNaNOrPercent(result, value, isPercent);
      if (res.ret) {
        return false;
      }
      ({ result } = res);
    }
    const judgeRes = _tryToDoubleTypestrBranchJudge(typestr, value);
    if (judgeRes.ret) {
      return false;
    }
    result = judgeRes.result;
  } catch (ex) {
    return false;
  }
  doubleValue.value = result;
  return true;
}
function _approxEqual(x, y) {
  const num = 16777216;
  return x === y ? true : Math_abs(x - y) < Math_abs(x) / (num * num);
}
function eMOOperatorTypeJudge(operatorType, doubleLeft, doubleRight, CalcErrorsDivideByZero) {
  if (operatorType === 0) {
    return doubleLeft;
  }
  if (operatorType === 1) {
    return -doubleLeft;
  }
  if (operatorType === 2) {
    return doubleLeft / 100;
  }
  if (operatorType === 3) {
    return doubleLeft + doubleRight;
  }
  if (operatorType === 4) {
    return doubleLeft - doubleRight;
  }
  if (operatorType === 5) {
    return doubleLeft * doubleRight;
  }
  if (operatorType === 6) {
    return doubleRight ? doubleLeft / doubleRight : CalcErrorsDivideByZero;
  }
  if (operatorType === 7) {
    return !doubleLeft && doubleRight < 0 ? CalcErrorsDivideByZero : Math_pow(doubleLeft, doubleRight);
  }
}

const evaluateMathOperatorSingleValue = function (operatorType, value1, value2) {
  function isEmptyString(str) {
    return typeof str === 'string' && str.trim().length === 0;
  }
  // eslint-disable-next-line no-unused-vars
  function _isNaNOrInfinite(value) {
    return isNaN(value) || !isFinite(value);
  }
  if (isEmptyString(value1) || isEmptyString(value2)) {
    return CalcErrorsValue;
  }
  const doubleValue = { value: 0 };
  if (!_tryToDouble(value1, doubleValue)) {
    if (operatorType === 0 && typeof value1 === 'string') {
      return value1;
    }
    return CalcErrorsValue;
  }
  const doubleLeft = doubleValue.value;
  let doubleRight;
  if (value2 !== keyword_undefined) {
    if (!_tryToDouble(value2, doubleValue)) {
      return CalcErrorsValue;
    }
    doubleRight = doubleValue.value;
  } else {
    doubleRight = 0;
  }
  return eMOOperatorTypeJudge(operatorType, doubleLeft, doubleRight, CalcErrorsDivideByZero);
};
const judgeOPtypeANDCompRes = (operatorType, compareResult) =>
  (operatorType === 9 && compareResult === 0) ||
  (operatorType === 10 && compareResult !== 0) ||
  (operatorType === 11 && compareResult < 0) ||
  (operatorType === 12 && compareResult <= 0) ||
  (operatorType === 13 && compareResult > 0) ||
  (operatorType === 14 && compareResult >= 0);

const directionBool = (leftBool, rightBool, left, right) => {
  let compareResult;
  if (leftBool && rightBool) {
    if (left === right) {
      compareResult = 0;
    } else {
      compareResult = left > right ? 1 : -1;
    }
  } else {
    compareResult = leftBool ? 1 : -1;
  }
  return compareResult;
};

const compare = (left, right, leftIsString, rightIsString) => {
  if (left === right) {
    return 0;
  }
  if (leftIsString && rightIsString) {
    return left.toUpperCase().localeCompare(right.toUpperCase());
  }
  if (leftIsString) {
    return 1;
  }
  if (rightIsString) {
    return -1;
  }
  return _approxEqual(left, right) ? 0 : left - right;
};

const directionDefault = (direction, defaultValue) =>
  direction === keyword_null || direction === keyword_undefined ? defaultValue : direction;

const evaluateCompareOperatorSingleValue = function (operatorType, left, right) {
  if (isCalcError(left)) {
    return left;
  }
  if (isCalcError(right)) {
    return right;
  }
  let compareResult;
  const leftBool = typeof left === const_boolean;
  const rightBool = typeof right === const_boolean;
  if (leftBool || rightBool) {
    compareResult = directionBool(leftBool, rightBool, left, right);
  } else {
    const leftIsString = typeof left === const_string;
    const rightIsString = typeof right === const_string;
    const isString = leftIsString || rightIsString;
    const defaultValue = isString ? '' : 0;
    left = directionDefault(left, defaultValue);
    right = directionDefault(right, defaultValue);

    if (!isString) {
      const doubleLeft = { value: 0 };
      const doubleRight = { value: 0 };
      if (!_tryToDouble(left, doubleLeft) || !_tryToDouble(right, doubleRight)) {
        return CalcErrorsValue;
      }
      left = doubleLeft.value;
      right = doubleRight.value;
    }

    compareResult = compare(left, right, leftIsString, rightIsString);
  }
  return judgeOPtypeANDCompRes(operatorType, compareResult);
};

const calcuRC = (isArg0Simple, isArg1Simple, rowArg0, rowArg1, colArg0, colArg1) => {
  let row;
  let col;
  if (!isArg0Simple.success && !isArg1Simple.success) {
    if (
      (rowArg0 !== 1 && rowArg1 !== 1 && rowArg0 !== rowArg1) ||
      (colArg0 !== 1 && colArg1 !== 1 && colArg0 !== colArg1)
    ) {
      return false;
    }
    row = rowArg0 === 1 ? rowArg1 : rowArg0;
    col = colArg0 === 1 ? colArg1 : colArg0;
  } else if (!isArg0Simple.success) {
    row = rowArg0;
    col = colArg0;
  } else {
    row = rowArg1;
    col = colArg1;
  }
  return { row, col };
};

const CalcErrorJudge = (row, col, isArg0Simple, isArg1Simple, rowArg0, colArg0, rowArg1, colArg1) =>
  (!isArg0Simple.success && ((rowArg0 !== 1 && rowArg0 < row) || (colArg0 !== 1 && colArg0 < col))) ||
  (!isArg1Simple.success && ((rowArg1 !== 1 && rowArg1 < row) || (colArg1 !== 1 && colArg1 < col)));

const generateResult = (
  row,
  col,
  isArg0Simple,
  isArg1Simple,
  rowArg0,
  colArg0,
  rowArg1,
  colArg1,
  evaluateSingleValue,
  left,
  right,
  operatorType,
) => {
  const result = [];
  for (let i = 0; i < row; i++) {
    result[i] = [];
    for (let j = 0; j < col; j++) {
      if (CalcErrorJudge(row, col, isArg0Simple, isArg1Simple, rowArg0, colArg0, rowArg1, colArg1)) {
        result[i][j] = CalcErrorsNotAvailable;
      } else {
        const fixedRowArg0 = rowArg0 === 1 ? 0 : i;
        const fixedColArg0 = colArg0 === 1 ? 0 : j;
        const fixedRowArg1 = rowArg1 === 1 ? 0 : i;
        const fixedColArg1 = colArg1 === 1 ? 0 : j;
        result[i][j] = evaluateSingleValue(
          operatorType,
          isArg0Simple.success ? left : left[fixedRowArg0][fixedColArg0],
          isArg1Simple.success ? right : right[fixedRowArg1][fixedColArg1],
        );
      }
    }
  }
  return result;
};

var evaluateMathOperator = function (operatorType, left, right) {
  let evaluateSingleValue;
  if (operatorType <= 7) {
    evaluateSingleValue = evaluateMathOperatorSingleValue;
  } else if (operatorType === 8) {
    evaluateSingleValue = evaluateStringOperatorSingleValue;
  } else {
    evaluateSingleValue = evaluateCompareOperatorSingleValue;
  }
  const isArg0Simple = tryExtractToSingleValue(left);
  const isArg1Simple = tryExtractToSingleValue(right);
  if (isArg0Simple.success && isArg1Simple.success) {
    return evaluateSingleValue(operatorType, isArg0Simple.value, isArg1Simple.value);
  }
  left = isArg0Simple.value;
  right = isArg1Simple.value;
  const rowArg0 = isArg0Simple.success ? -1 : left.rowCount;
  const colArg0 = isArg0Simple.success ? -1 : left.colCount;
  const rowArg1 = isArg1Simple.success ? -1 : right.rowCount;
  const colArg1 = isArg1Simple.success ? -1 : right.colCount;
  let row = -1;
  let col = -1;
  const rcRes = calcuRC(isArg0Simple, isArg1Simple, rowArg0, rowArg1, colArg0, colArg1);
  if (!rcRes) {
    return CalcErrorsNotAvailable;
  }
  ({ row, col } = rcRes);
  const result = generateResult(
    row,
    col,
    isArg0Simple,
    isArg1Simple,
    rowArg0,
    colArg0,
    rowArg1,
    colArg1,
    evaluateSingleValue,
    left,
    right,
    operatorType,
  );
  return new Calc.CalcArray(result);
};
/**
 * =============初始化控制点变化方法=================== */
function setShapeControlPoints(target, model) {
  const { variables } = model;
  const node = model.controlsInfo;
  if (node) {
    if (model.controls) {
      return model;
    }

    const controls = (model.controls = []);
    const angleAdjustments = (model.angleAdjustments = {});
    node.forEach((item) => {
      const result = { xBehavior: 1, yBehavior: 1 };
      const pos = item.position;
      const xName = pos.x;
      const yName = pos.y;
      const names = item.point;
      result.x = names[0];
      result.y = names[1];
      if (item.type === 'ahXY') {
        const adjX = item.gdRefX;
        const adjY = item.gdRefY;
        if (adjX) {
          getAdjustFormula(xName, adjX, variables, target);
          result.xBehavior = 0;
          result.xRef = adjX;
          result.min = item.minX;
          result.max = item.maxX;
        }

        if (adjY) {
          getAdjustFormula(yName, adjY, variables, target);
          result.yBehavior = 0;
          result.yRef = adjY;
          result.min = item.minY;
          result.max = item.maxY;
        }
      } else {
        const adjAngle = item.gdRefAng;
        const adjRadius = item.gdRefR;
        result.xBehavior = 0;
        result.yBehavior = 0;
        result.aRef = adjAngle;
        result.rRef = adjRadius;
        if (adjAngle) {
          result.minAngle = item.minAng;
          result.maxAngle = item.maxAng;

          angleAdjustments[adjAngle] = item.maxAng === 0 ? 2 : 1;
        }
        if (adjRadius) {
          result.minRadius = item.minR;
          result.maxRadius = item.maxR;
          getPolarAdjustInfo(xName, yName, adjRadius, variables, target);
        }
      }
      controls.push(result);
    });
  }
}
function getAdjustFormula(name, adjName, src, target, varAdjName) {
  if (!target.definition.fnDefs) {
    target.definition.fnDefs = {};
    target.definition.fnArgs = {};
  } else if (target.definition.fnDefs[adjName]) {
    return;
  }
  const args = [];
  const lines = [];
  varAdjName = varAdjName || adjName;
  getAdjustStatements(src, name, lines, args, varAdjName, true);

  let result;
  const count = args.length;
  if (count > 0) {
    const sResult = lines.pop();
    const vars = lines.length ? ['var\t', lines.join(',\r\n\t'), ';\r\n'].join('') : '';
    const body = `${vars}return ${sResult};`;

    if (count === 1) {
      result = new Function('width', 'height', args[0], body);
    } else if (count === 2) {
      result = new Function('width', 'height', args[0], args[1], body);
    } else if (count === 3) {
      result = new Function('width', 'height', args[0], args[1], args[2], body);
    } else if (count === 4) {
      result = new Function('width', 'height', args[0], args[1], args[2], args[3], body);
    } else if (count === 5) {
      result = new Function('width', 'height', args[0], args[1], args[2], args[3], args[4], body);
    } else {
      return;
    }
  }
  target.definition.fnDefs[adjName] = result;
  target.definition.fnArgs[adjName] = args;
}
function modifyShapeControls(shapeModel, autoShapeType) {
  if (autoShapeType === 'mathNotEqual') {
    shapeModel.controls[1].adjustInfo = {
      toHalfCircle: true,
    };
  } else if (autoShapeType === 'leftCircularArrow') {
    shapeModel.controls[0].adjustInfo = {
      toNegative: true,
    };
  }
}
function convertFormulaToFunction(str) {
  return str
    .replace(/MIN\(/g, 'Math.min(')
    .replace(/MAX\(/g, 'Math.max(')
    .replace(/SIN\(/g, 'Math.sin(')
    .replace(/COS\(/g, 'Math.cos(')
    .replace(/ABS\(/g, 'Math.abs(')
    .replace(/ATAN2\(([^,]+)\,([^,\)]+)\)/g, 'Math.atan2($2, $1)')
    .replace(/SQRT\(/g, 'Math.sqrt(')
    .replace(/TAN\(/g, 'Math.tan(')
    .replace(/IF\(([^,]+), ([^,]+), ([^,]+)\)/g, '($1 ? $2 : $3)');
}

const regVarName = /V\.(_?[A-Za-z0-9]+)/g;
const prefixLength = 'V.'.length;

function getAdjustStatements(src, name, lines, args, varAdjName, isResult) {
  const f = src[name];

  if (/^\d/.test(name)) {
    name = `_${name}`;
  }

  if (!isNaN(+f)) {
    lines.push(`${name} = ${f}`);
  } else {
    let s = convertFormulaToFunction(f);
    const names = s.match(regVarName);
    if (names && names.length) {
      s = s.replace(/V\.(\d)/g, '_$1').replace(/V\./g, '');
      names.forEach((n) => {
        const varName = n.substr(prefixLength);

        if (varName.indexOf('adj') === 0) {
          if (args.indexOf(varName) === -1) {
            if (varName === varAdjName) {
              args.unshift(varName);
            } else {
              args.push(varName);
            }
          }
          return;
        }

        if (!lines[varName]) {
          lines[varName] = true;
          getAdjustStatements(src, varName, lines, args, varAdjName);
        }
      });
    }
    lines.push((isResult ? '' : `${name} = `) + s.substr(1));
  }
}
function getPolarAdjustInfo(xName, yName, adjName, src, target) {
  getAdjustFormula(xName, `${adjName}_x`, src, target, adjName);
  getAdjustFormula(yName, `${adjName}_y`, src, target, adjName);
}
/**
 * ==================计算并修改控制点===================== */
function changeVariablePoint(type, index, point, ps, width, height, changePoint, ajustInfos) {
  const self = ps.defination[type];
  const { fnDefs } = self;
  const w = width;
  const h = height;
  const rect = {
    width: w,
    height: h,
    index,
    x: 0,
    y: 0,
  };
  const controlPoint = self.controls[rect.index];

  let r;
  let newFn;
  let path;
  let f;

  const center = {
    x: w / 2,
    y: h / 2,
  };
  const pt = rotatePoint({ x: point.x - center.x, y: point.y - center.y }, { x: 0, y: 0 }, -toRadius(self.angle));

  const currentX = pt.x + w / 2;
  const currentY = pt.y + h / 2;

  const { aRef } = controlPoint;
  const { rRef } = controlPoint;
  if (aRef || rRef) {
    return updatePolarAdjustValue(
      type,
      ps,
      controlPoint,
      [aRef, rRef],
      w,
      h,
      currentX,
      currentY,
      index,
      changePoint,
      ajustInfos,
    );
  }

  if (controlPoint.xBehavior === 0) {
    if (fnDefs) {
      updateAdjustValue(type, ps, controlPoint, controlPoint.xRef, w, h, currentX, index, changePoint, ajustInfos);
    } else {
      r = currentX / w;
      newFn = `${r}*width`;
      path = `controls.${rect.index}.x`;
      f = ps.getFormula(self.id, path);
      newFn = self.getBoundFn(f, newFn);

      ps.setFormula(self.id, path, newFn);
    }
  }

  if (controlPoint.yBehavior === 0) {
    if (fnDefs) {
      updateAdjustValue(type, ps, controlPoint, controlPoint.yRef, w, h, currentY, index, changePoint, ajustInfos);
    } else {
      r = currentY / h;
      newFn = `${r}*height`;
      path = `controls.${rect.index}.y`;
      f = ps.getFormula(self.id, path);
      newFn = self.getBoundFn(f, newFn);

      ps.setFormula(self.id, path, newFn);
    }
  }

  return changePoint;
}
function updateAdjustValue(type, service, controlPoint, name, width, height, value, index, changePoint, ajustInfos) {
  const shape = this;
  const fnNames = [name];
  const rangeValue = getControlPointRange(type, service, [controlPoint.min, controlPoint.max]);
  const tmp = getAdjustValue(type, service, fnNames, width, height, value, keyword_undefined, rangeValue, shape);
  if (tmp) {
    for (let i = 0; i < ajustInfos.length; i++) {
      if (ajustInfos[i][0] == name) {
        changePoint[i] = tmp.value / 100000;
      }
    }
  }
  return changePoint;
}
function updatePolarAdjustValue(
  type,
  service,
  controlPoint,
  names,
  width,
  height,
  targetX,
  targetY,
  index,
  changePoint,
  ajustInfos,
) {
  const shape = this;
  let value;
  let name;
  if (controlPoint.maxAngle) {
    name = names[0];
    const point = { x: width / 2, y: height / 2 };
    const angle = getAdjustAngle(0, point.x, point.y, targetX, targetY, controlPoint.adjustInfo); // shape.angle  todo
    value = getValueInRange(getControlPointRange(type, service, [controlPoint.minAngle, controlPoint.maxAngle]), angle);
    for (let i = 0; i < ajustInfos.length; i++) {
      if (ajustInfos[i][0] == name) {
        changePoint[i] = value / 100000;
      }
    }
  }
  name = names[1];
  if (name) {
    const fnNames = [`${name}_x`, `${name}_y`];
    const rangeValue = getControlPointRange(type, service, [controlPoint.minRadius, controlPoint.maxRadius]);
    const tmp = getAdjustValue(type, service, fnNames, width, height, targetX, targetY, rangeValue, shape);
    if (tmp) {
      value = tmp.value;
      self.id;

      for (let i = 0; i < ajustInfos.length; i++) {
        if (ajustInfos[i][0] == name) {
          changePoint[i] = tmp.value / 100000;
        }
      }
    }
  }
  return changePoint;
}
function getControlPointRange(type, service, items) {
  return items.map((v) => {
    const n = +v;
    if (isNaN(n)) {
      return service.getValue(type, `variables.${v}`);
    }
    return n;
  });
}
const DIFF_LIMIT = 1.0e-10;
const CALC_COUNT_LIMIT = 100;
const getAdjustValueCalcu = (
  fnX,
  targetX,
  targetY,
  minValue,
  maxValue,
  isReversed,
  maxX,
  minX,
  v0,
  diffX,
  diffValue,
  fn,
) => {
  let value;
  let d;
  const targetValue = fnX ? targetX : targetY;
  if (targetValue < minValue) {
    value = isReversed ? maxX : minX;
  } else if (targetValue > maxValue) {
    value = isReversed ? minX : maxX;
  } else {
    let x = Math.abs(((targetValue - v0) * diffX) / diffValue) + minX;
    let y = evaluteFunction(fn, x);
    let n = 0;
    let last = 0;
    d = y - targetValue;
    while (Math.abs(d) > DIFF_LIMIT) {
      x += (diffX * d) / diffValue;
      y = evaluteFunction(fn, x);
      d = y - targetValue;
      if (last - d < DIFF_LIMIT) {
        break;
      }
      last = d;
      n += 1;
      if (n > CALC_COUNT_LIMIT) {
        break;
      }
    }
    value = x;
  }
  return { value, d };
};

function getAdjustValue(type, ps, fnNames, width, height, targetX, targetY, valueRange) {
  const [minX, maxX] = valueRange;
  const diffX = maxX - minX;
  const { fnDefs } = ps.defination[type];
  const { fnArgs } = ps.defination[type];
  const fnX = fnDefs[fnNames[0]];
  const fnY = fnDefs[fnNames[1]];
  if (!fnX && !fnY) {
    return;
  }
  const fn = getBoundFunction(fnX || fnY, width, height);
  let values;
  const service = ps;
  const id = ps.objectId_;
  if (fnX) {
    if (fnX.length > 3) {
      values = fnArgs[fnNames[0]].slice(1).map((name) => service.getValue(id, `variables.${name}`));
    }
  } else if (fnY.length > 3) {
    values = fnArgs[fnNames[1]].slice(1).map((name) => service.getValue(id, `variables.${name}`));
  }
  fn.values = values || [];
  const v0 = evaluteFunction(fn, minX);
  const v1 = evaluteFunction(fn, maxX);
  const isReversed = v0 > v1;
  const diffValue = v0 - v1;
  const range = [v0, v1];
  const offset = isReversed ? 1 : 0;
  const minValue = range[offset % 2];
  const maxValue = range[(offset + 1) % 2];
  const result = {
    min: minValue,
    max: maxValue,
    reversed: isReversed,
  };

  // eslint-disable-next-line no-unused-vars
  const { value, d } = getAdjustValueCalcu(
    fnX,
    targetX,
    targetY,
    minValue,
    maxValue,
    isReversed,
    maxX,
    minX,
    v0,
    diffX,
    diffValue,
    fn,
  );

  result.value = value;

  return result;
}
function evaluateBoundFunction() {
  const _this = this;
  return _this._fn.apply(null, [].concat.apply([_this._width, _this._height], arguments));
}
function getBoundFunction(fn, width, height) {
  const bindObject = { _fn: fn, _width: width, _height: height };
  return evaluateBoundFunction.bind(bindObject);
}
function evaluteFunction(fn, value) {
  const values = [value].concat(fn.values);
  return fn.apply(null, values);
}
function getValueInRange(range, value) {
  return Math.min(range[1], Math.max(range[0], value));
}
const oneDegreeInExcelAngle = 60000;
const radianToExcelAngle = (oneDegreeInExcelAngle * 180) / Math.PI;
const circleExcelAngle = oneDegreeInExcelAngle * 360;
const halfCircleExcelAngle = oneDegreeInExcelAngle * 180;
function getAdjustAngle(rotateAngle, cx, cy, x, y, adjustInfo) {
  let theta = Math.atan2(y - cy, x - cx) * radianToExcelAngle;
  if (rotateAngle) {
    //
  }
  if (adjustInfo) {
    if (adjustInfo.toHalfCircle && theta < 0) {
      theta += halfCircleExcelAngle;
    } else if (adjustInfo.toNegative && theta > 0) {
      theta -= halfCircleExcelAngle;
    }
  } else if (theta < 0) {
    theta += circleExcelAngle;
  }
  return theta;
}
// = ====================================================================

const SpreadJS = (function () {
  let instance = null;
  function SpreadJS() {
    if (instance) {
      return instance;
    }
    return (instance = this);
  }
  return SpreadJS;
})();

SpreadJS.prototype = {
  // 初始化预设操作
  getBaseShape(shapeType) {
    const excelShapeName = this.getAutoShapeType(shapeType);
    this.excelShapeName = excelShapeName;
    const shapeInfo = PresetShapeModels[excelShapeName];
    if (shapeInfo == null) {
      console.error('[alloy-graphics][spreadjs] shapeInfo is null');
      return;
    }
    shapeInfo.id = excelShapeName;
    return shapeInfo;
  },
  getAutoShapeType(shapeType) {
    let AutoShapeTypeDict = {};
    let excelShapeName = GraphicsType.RECT;
    if (this.autoShapeTypeDict == undefined) {
      // 转化原始PPTtype类型为预设操作type类型
      for (const p in AutoShapeType) {
        if (AutoShapeType.hasOwnProperty(p)) {
          AutoShapeTypeDict[AutoShapeType[p]] = p;
        }
      }
      this.autoShapeTypeDict = AutoShapeTypeDict;
    } else {
      AutoShapeTypeDict = this.autoShapeTypeDict;
    }

    if (ST_ShapeType.hasOwnProperty(shapeType)) {
      const type = ToAutoShapeType(ST_ShapeType[shapeType]);
      excelShapeName = AutoShapeTypeDict[type];
    }
    return excelShapeName;
  },
  getPropertySource(value, width, height) {
    let s = this.propertySource;
    if (value == undefined) {
      return s;
    }
    const id = this.excelShapeName;
    const defination = {
      definition: value,
      name: this.excelShapeName,
    };

    if (s && has(s.store_, id)) {
      return s;
    }
    setShapeControlPoints(defination, value);
    modifyShapeControls(defination.definition, id);
    if (s == undefined) {
      s = PropertySource.createNew(defination);
    }

    if (!has(s.store_, id)) {
      s.store_[id] = {};
      s.store_[id].width = { value: width };
      s.store_[id].height = { value: height };
      s.store_[id].left = { value: 0 };
      s.store_[id].top = { value: 0 };
      s.store_[id].angle = { value: 0 };
    }
    if (!has(s.defination, id)) {
      s.defination[id] = defination.definition;
    }
    if (value) {
      s.defineProperties();
    }
    s.setObject(id, '', defination.definition);

    return (this.propertySource = s);
  },
  getPath(type, w, h, controlValues) {
    if (!this.isTypeExist(type)) return;
    const s = this.propertySource;
    const dataType = this.getAutoShapeType(type);
    this.resize(dataType, w, h);
    this.setControlValues(dataType, controlValues);
    return s.getValuesForObject(dataType, 'path');
  },
  resize(type, w, h) {
    const s = this.propertySource;
    const defination = s.defination[type];

    if (has(s.store_, type)) {
      s.store_[type].width = { value: w };
      s.store_[type].height = { value: h };
      s.setObject(type, '', defination);
    }
  },
  setControlValues(type, controlValues) {
    if (!this.isTypeExist(type)) return;
    if (!controlValues || controlValues.length == 0) return;
    const s = this.propertySource;
    const defination = s.defination[type];
    const adjInfo = this.getDefaultadjustInfo(type);
    if (typeof adjInfo === 'undefined') {
      return;
    }
    for (let i = 0; i < controlValues.length; i++) {
      const name = adjInfo[i][0];
      defination.variables[name] = controlValues[i] * 100000;
    }

    if (has(s.store_, type)) {
      s.setObject(type, '', defination);
    }
  },
  getTextRect(type, controlValues, w, h) {
    if (!this.isTypeExist(type)) return;
    const s = this.propertySource;
    const dataType = this.getAutoShapeType(type);
    this.resize(dataType, w, h);
    this.setControlValues(dataType, controlValues);
    return s.getValuesForObject(dataType, 'textRect');
  },
  getControlinfos(type, controlValues, w, h) {
    if (!this.isTypeExist(type)) return;
    const s = this.propertySource;
    const dataType = this.getAutoShapeType(type);
    this.resize(dataType, w, h);
    this.setControlValues(dataType, controlValues);
    return s.getValuesForObject(this.getAutoShapeType(type), 'controlsInfo');
  },
  getControls(type) {
    if (!this.isTypeExist(type)) return;
    const s = this.propertySource;
    return s.getValuesForObject(this.getAutoShapeType(type), 'controls');
  },
  changeVariable(type, controlPointIndex, newPosWithRect, w, h, oldControlValues) {
    const shapeType = this.getAutoShapeType(type);
    const s = this.propertySource;
    const ajustInfos = this.getDefaultadjustInfo(shapeType);
    if (oldControlValues.length == 0 && this.getControlPointNums(shapeType) > 0) {
      oldControlValues = this.getDefaultcontrolInfos(shapeType);
    }
    return changeVariablePoint(shapeType, controlPointIndex, newPosWithRect, s, w, h, oldControlValues, ajustInfos);
  },
  getControlPointNums(type) {
    if (!this.isTypeExist(type)) return;
    const s = this.propertySource;
    return s.getValuesForObject(type, 'adjustInfo').adjustInfo.length;
  },
  getDefaultadjustInfo(type) {
    if (!this.isTypeExist(type)) return;
    const s = this.propertySource;
    const adjustInfos = s.getValuesForObject(type, 'adjustInfo').adjustInfo;

    return adjustInfos;
  },
  getDefaultcontrolInfos(type) {
    if (!this.isTypeExist(type)) return;
    const s = this.propertySource;
    const adjustInfos = s.getValuesForObject(type, 'adjustInfo').adjustInfo;
    const defaultcontrolInfos = [];
    if (adjustInfos != undefined) {
      let i = 0;
      adjustInfos.map((item) => {
        defaultcontrolInfos[i] = item[1] / 100000;
        i += 1;
      });
    }
    return defaultcontrolInfos;
  },
  getConnectionPoints(type, w, h, controlValues) {
    const dataType = this.getAutoShapeType(type);
    const s = this.propertySource;
    this.resize(dataType, w, h);
    this.setControlValues(dataType, controlValues);
    const { connectionPoints } = s.getValuesForObject(dataType, 'connectionPoints');

    return connectionPoints;
  },
  isTypeExist(type) {
    if (type == null) {
      console.error('[alloy-graphics][spreadjs] shapetype is null');
      return false;
    }
    return true;
  },
};
export { SpreadJS };
